import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APIMS } from "../../../../../../../config/apims";
import { APISD } from "../../../../../../../config/apisd";
import { APISM } from "../../../../../../../config/apism";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { useLocation, useNavigate, Link } from "react-router-dom";
import ToastError from "../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PulseLoader } from "react-spinners";
import {
  faList,
  faTrash,
  faPenToSquare,
  faChalkboardUser,
  faBook,
  faPlus,
  faMagnifyingGlass,
  faUsers,
  faUserPlus,
  faArrowLeft,
  faBookOpen,
  faChalkboardTeacher,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import ModalAdd from "./modal/cofigeEkskul";
import ModalUpdate from "./modal/update";
import ModalConfigTeacher from "./modal/configTeacher";
import ModalUpdateConfigTeacher from "./modal/updateTeacher";
import ModalConfigStudent from "./modal/configStudent";
import "./configMatpel-ekstra.css";

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }
`;

const cleanStorageValue = (value) => {
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    value === "undefined" ||
    value === "null"
  ) {
    return "";
  }

  return String(value)
    .replace(/^['"]|['"]$/g, "")
    .trim();
};

const toDateInputValue = (value) => {
  if (!value) return "";

  const normalized = String(value).trim();

  if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
    return normalized;
  }

  if (/^\d{4}-\d{2}-\d{2}[T\s]/.test(normalized)) {
    return normalized.slice(0, 10);
  }

  return "";
};

const toApiNumber = (value) => {
  if (
    value === "" ||
    value === null ||
    value === undefined
  ) {
    return null;
  }

  const numberValue = Number(value);

  return Number.isNaN(numberValue)
    ? value
    : numberValue;
};

const getScoreId = (student) => {
  const scoreId = cleanStorageValue(
    student?.score_id ||
      student?.ysb_ekstrakurikuler_score_id ||
      student?.id_score
  );

  return scoreId || "default";
};

const extractScoreIdFromResponse = (response) => {
  const candidates = [
    response?.data?.data?.score_id,
    response?.data?.data?.ysb_ekstrakurikuler_score_id,
    response?.data?.data?.id_score,
    response?.data?.data?.id,

    response?.data?.score_id,
    response?.data?.ysb_ekstrakurikuler_score_id,
    response?.data?.id_score,
    response?.data?.id,
  ];

  const found = candidates.find((item) => {
    const value = cleanStorageValue(item);

    return value && value !== "default";
  });

  return found ? cleanStorageValue(found) : "";
};

const getLoginUserName = () => {
  const nameAdmin = cleanStorageValue(
    localStorage.getItem("name-admin")
  );

  if (nameAdmin) {
    return nameAdmin;
  }

  const directKeys = [
    "username",
    "nama_lengkap",
    "name",
    "nama",
    "user_name",
    "name_user",
  ];

  for (const key of directKeys) {
    const value = cleanStorageValue(
      localStorage.getItem(key)
    );

    if (value) {
      return value;
    }
  }

  const objectKeys = [
    "user",
    "user_data",
    "data_user",
    "auth_user",
  ];

  for (const key of objectKeys) {
    try {
      const raw = localStorage.getItem(key);

      if (!raw) continue;

      const user = JSON.parse(raw);

      const candidates = [
        user?.username,
        user?.nama_lengkap,
        user?.name,
        user?.nama,
        user?.user_name,
        user?.name_user,

        user?.teacher?.username,
        user?.teacher?.nama_lengkap,
        user?.teacher?.name,

        user?.data?.username,
        user?.data?.nama_lengkap,
        user?.data?.name,
        user?.data?.nama,

        user?.data?.user?.username,
        user?.data?.user?.nama_lengkap,
        user?.data?.user?.name,

        user?.data?.teacher?.username,
        user?.data?.teacher?.nama_lengkap,
        user?.data?.teacher?.name,
      ];

      const found = candidates.find((item) =>
        cleanStorageValue(item)
      );

      if (found) {
        return cleanStorageValue(found);
      }
    } catch (error) {
      // abaikan
    }
  }

  return "User Login";
};

const getLoginUserId = () => {
  const directKeys = [
    "user_id",
    "id_user",
    "id-user",
    "user-id",
    "userId",
    "id-admin",
    "id_admin",
    "ysb_user_id",
  ];

  for (const key of directKeys) {
    const value = cleanStorageValue(
      localStorage.getItem(key)
    );

    if (value) {
      return value;
    }
  }

  const objectKeys = [
    "user",
    "user_data",
    "data_user",
    "auth_user",
  ];

  for (const key of objectKeys) {
    try {
      const raw = localStorage.getItem(key);

      if (!raw) continue;

      const user = JSON.parse(raw);

      const candidates = [
        user?.user_id,
        user?.id_user,
        user?.id,
        user?.ysb_user_id,

        user?.data?.user_id,
        user?.data?.id_user,
        user?.data?.id,
        user?.data?.ysb_user_id,

        user?.data?.user?.user_id,
        user?.data?.user?.id_user,
        user?.data?.user?.id,
        user?.data?.user?.ysb_user_id,
      ];

      const found = candidates.find((item) =>
        cleanStorageValue(item)
      );

      if (found) {
        return cleanStorageValue(found);
      }
    } catch (error) {
      // abaikan
    }
  }

  return "";
};

const getDetailData = (responseData) => {
  if (
    responseData?.data?.data &&
    !Array.isArray(responseData.data.data)
  ) {
    return responseData.data.data;
  }

  if (
    responseData?.data &&
    !Array.isArray(responseData.data)
  ) {
    return responseData.data;
  }

  return {};
};

function NilaiEkskulTab({
  selectedMatpel,
  selectedAcademicYearId,
  selectedSemesterId,
  getToken,
  getBranchId,
  getSchoolId,
  onBack,
  embedded = true,
  semesterOptions = [],
  onSemesterChange,
  studentSearchKeyword = "",
  prefetchedDetailData,
  prefetchedLoading = false,
}) {
  const [isFetching, setIsFetching] = useState(true);
  const [detailData, setDetailData] = useState({});
  const [selectedKelasId, setSelectedKelasId] =
    useState("");
  const [studentInputs, setStudentInputs] = useState({});

  /*
   * Ref ini menyimpan value terbaru dari form.
   * Jadi tidak perlu menunggu render React.
   */
  const studentInputsRef = useRef({});

  /*
   * Menyimpan score_id terbaru masing-masing siswa.
   *
   * Kalau awalnya default:
   * default -> CREATE
   *
   * Setelah API memberikan ID baru:
   * UUID -> UPDATE
   */
  const scoreIdRef = useRef({});

  /*
   * Queue request per siswa.
   *
   * tanggal mulai -> tanggal akhir -> nilai
   *
   * request tidak sama-sama memakai /default.
   */
  const saveQueueRef = useRef({});

  const loginUserName = useMemo(
    () => getLoginUserName(),
    []
  );

  const ekstrakurikulerId =
    selectedMatpel?.ysb_matpel_id ||
    selectedMatpel?.id ||
    "";

  useEffect(() => {
    if (embedded) return;

    document.title = selectedMatpel?.nama_matpel
      ? `${selectedMatpel.nama_matpel} - Ekstrakurikuler`
      : "Input Nilai";
  }, [selectedMatpel, embedded]);

  /*
   * =========================================================
   * DETAIL NILAI DARI CACHE HOME
   * =========================================================
   *
   * Request GET nilai sekarang dilakukan di Home sejak halaman
   * pertama kali memuat data. Karena itu saat user membuka tab
   * Nilai, komponen ini cukup membaca data yang sudah tersedia
   * dan tidak melakukan GET ulang hanya karena pindah tab.
   */

  useEffect(() => {
    if (prefetchedLoading) {
      setIsFetching(true);
      return;
    }

    setDetailData(prefetchedDetailData || {});
    setIsFetching(false);
  }, [prefetchedDetailData, prefetchedLoading]);

  /*
   * =========================================================
   * GRADE LEVEL
   * =========================================================
   */

  const visibleGradeLevels = useMemo(() => {
    const gradeLevels = Array.isArray(
      detailData?.grade_levels
    )
      ? detailData.grade_levels
      : [];

    const selectedGradeIds = Array.isArray(
      selectedMatpel?.selected_grade_level_ids
    )
      ? selectedMatpel.selected_grade_level_ids.filter(
          Boolean
        )
      : [
          selectedMatpel?.ysb_grade_level_id,
        ].filter(Boolean);

    if (selectedGradeIds.length === 0) {
      return gradeLevels;
    }

    const filtered = gradeLevels.filter((grade) =>
      selectedGradeIds.some(
        (id) =>
          String(id) ===
          String(
            grade?.ysb_grade_level_id || ""
          )
      )
    );

    return filtered.length > 0
      ? filtered
      : gradeLevels;
  }, [detailData, selectedMatpel]);

  /*
   * =========================================================
   * LIST KELAS
   * =========================================================
   */

  const kelasList = useMemo(() => {
    const list = visibleGradeLevels.flatMap((grade) => {
      const kelas = Array.isArray(
        grade?.kelas
      )
        ? grade.kelas
        : [];

      return kelas.map((item) => ({
        ...item,

        ysb_grade_level_id:
          grade?.ysb_grade_level_id || "",

        // Endpoint nilai juga mengirim name_level langsung di dalam kelas.
        // Utamakan value tersebut agar judul card menjadi "Kelas 1 Arafah".
        name_level:
          item?.name_level || grade?.name_level || "",
      }));
    });

    // Samakan urutan card dengan tab Pembina: Arafah, Madinah, Makkah.
    return list.sort((a, b) =>
      String(a?.name_kelas || "").localeCompare(
        String(b?.name_kelas || ""),
        "id",
        { numeric: true, sensitivity: "base" }
      )
    );
  }, [visibleGradeLevels]);

  const formatClassText = (value) =>
    String(value || "")
      .toLocaleLowerCase("id-ID")
      .replace(/(^|[\s-])([a-z])/g, (match, separator, letter) =>
        `${separator}${letter.toLocaleUpperCase("id-ID")}`
      );

  /*
   * =========================================================
   * AUTO PILIH KELAS PERTAMA
   * =========================================================
   */

  useEffect(() => {
    if (kelasList.length === 0) {
      setSelectedKelasId("");
      return;
    }

    const stillExists = kelasList.some(
      (kelas) =>
        String(
          kelas?.ysb_kelas_id || ""
        ) === String(selectedKelasId)
    );

    if (!stillExists) {
      setSelectedKelasId(
        kelasList[0]?.ysb_kelas_id || ""
      );
    }
  }, [kelasList, selectedKelasId]);

  /*
   * =========================================================
   * KELAS TERPILIH
   * =========================================================
   */

  const selectedKelas = useMemo(() => {
    return (
      kelasList.find(
        (kelas) =>
          String(
            kelas?.ysb_kelas_id || ""
          ) === String(selectedKelasId)
      ) ||
      kelasList[0] ||
      null
    );
  }, [kelasList, selectedKelasId]);

  /*
  * =========================================================
  * PEMBINA KELAS TERPILIH
  * =========================================================
  */

  const pembinaList = useMemo(() => {
    const pembina = Array.isArray(
      selectedKelas?.pembina
    )
      ? selectedKelas.pembina
      : [];

    return pembina
      .map((item) => item?.nama_pembina)
      .filter(Boolean);
  }, [selectedKelas]);

  /*
   * =========================================================
   * SEMESTER TERPILIH
   * =========================================================
   */

  const activeSemester = useMemo(() => {
    const semesters = Array.isArray(
      selectedKelas?.semesters
    )
      ? selectedKelas.semesters
      : [];

    return (
      semesters.find(
        (semester) =>
          String(
            semester?.ysb_semester_id ||
              semester?.id ||
              ""
          ) ===
          String(selectedSemesterId || "")
      ) || null
    );
  }, [
    selectedKelas,
    selectedSemesterId,
  ]);

  /*
   * =========================================================
   * SISWA
   * =========================================================
   */

  const allStudents = useMemo(() => {
    const rows = Array.isArray(
      activeSemester?.students
    )
      ? activeSemester.students
      : [];

    return [...rows].sort((a, b) =>
      String(
        a?.nama_lengkap || ""
      ).localeCompare(
        String(b?.nama_lengkap || ""),
        "id",
        {
          sensitivity: "base",
          numeric: true,
        }
      )
    );
  }, [activeSemester]);

  const students = useMemo(() => {
    const keyword = String(studentSearchKeyword || "")
      .trim()
      .toLowerCase();

    if (!keyword) return allStudents;

    return allStudents.filter((student) => {
      const name = String(student?.nama_lengkap || "").toLowerCase();
      const nisn = String(student?.nisn || "").toLowerCase();
      return name.includes(keyword) || nisn.includes(keyword);
    });
  }, [allStudents, studentSearchKeyword]);

  /*
   * =========================================================
   * KEY SISWA
   * =========================================================
   */

  const getStudentKey = (
    student,
    index = 0
  ) =>
    String(
      student?.ysb_ekstrakurikuler_student_id ||
        student?.ysb_student_id ||
        student?.nisn ||
        `student-${index}`
    );

  /*
   * =========================================================
   * MASUKKAN DATA API KE FORM
   * =========================================================
   */

  useEffect(() => {
    const nextInputs = {};

    allStudents.forEach((student, index) => {
      const studentKey =
        getStudentKey(student, index);

      const serverScoreId =
        getScoreId(student);

      /*
       * Kalau sebelumnya sudah berhasil CREATE
       * dan score_id baru sudah kita simpan,
       * jangan timpa lagi menjadi default.
       */
      const knownScoreId =
        cleanStorageValue(
          scoreIdRef.current[studentKey]
        );

      const effectiveScoreId =
        knownScoreId &&
        knownScoreId !== "default"
          ? knownScoreId
          : serverScoreId;

      scoreIdRef.current[studentKey] =
        effectiveScoreId;

      nextInputs[studentKey] = {
        score_id: effectiveScoreId,

        date_start:
          toDateInputValue(
            student?.date_start
          ),

        date_end:
          toDateInputValue(
            student?.date_end
          ),

        score_mid:
          student?.score_mid === null ||
          student?.score_mid === undefined
            ? ""
            : String(student.score_mid),

        predikat_mid:
          student?.predikat_mid === null ||
          student?.predikat_mid === undefined
            ? ""
            : String(student.predikat_mid),

        comment_mid:
          student?.comment_mid || "",

        score_final:
          student?.score_final === null ||
          student?.score_final === undefined
            ? ""
            : String(student.score_final),

        predikat_final:
          student?.predikat_final === null ||
          student?.predikat_final === undefined
            ? ""
            : String(student.predikat_final),

        comment_final:
          student?.comment_final || "",
      };
    });

    studentInputsRef.current =
      nextInputs;

    setStudentInputs(nextInputs);
  }, [allStudents]);

  /*
   * =========================================================
   * UPDATE FORM LOKAL
   * =========================================================
   */

  const handleStudentInputChange = (
    studentKey,
    field,
    value
  ) => {
    const currentRow =
      studentInputsRef.current[
        studentKey
      ] || {};

    const nextRow = {
      ...currentRow,
      [field]: value,
    };

    /*
     * Ref langsung berubah.
     * Jadi queueAutoSave bisa langsung membaca
     * value terbaru.
     */
    studentInputsRef.current = {
      ...studentInputsRef.current,

      [studentKey]: nextRow,
    };

    setStudentInputs((prev) => ({
      ...prev,

      [studentKey]: nextRow,
    }));
  };

  /*
   * =========================================================
   * FALLBACK CARI SCORE ID BARU
   * =========================================================
   *
   * Dipakai kalau response:
   *
   * PUT /api/ekstrakurikuler-scores/default
   *
   * tidak mengembalikan score_id baru.
   *
   * Kita GET lagi data siswa, tetapi hanya mencari
   * ID-nya saja. Tidak mereset semua form.
   */

  const findCreatedScoreIdFromServer =
    async (saveContext) => {
      try {
        const token = getToken();

        const response =
          await APISD.request({
            method: "GET",

            url: `/api/ekstrakurikuler-scores`,

            headers: {
              Authorization: token,
              "Content-Type":
                "application/json",
            },

            params: {
              ysb_academic_year_id:
                saveContext.ysb_academic_year_id,

              ysb_branch_id:
                saveContext.ysb_branch_id,

              ysb_school_id:
                saveContext.ysb_school_id,

              ysb_grade_level_id:
                saveContext.ysb_grade_level_id,
            },

            data: {
              ysb_academic_year_id: saveContext.ysb_academic_year_id,
              ysb_branch_id: saveContext.ysb_branch_id,
              ysb_school_id: saveContext.ysb_school_id,
              ysb_grade_level_id: saveContext.ysb_grade_level_id,
            },
          });

        const latestRow = (Array.isArray(response?.data?.data)
          ? response.data.data
          : []
        ).find(
          (item) =>
            String(item?.ysb_matpel_id || item?.id || "") ===
            String(saveContext.ysb_matpel_id || "")
        );

        const latestDetail = latestRow
          ? {
              ...latestRow,
              grade_levels: [
                {
                  ysb_grade_level_id: saveContext.ysb_grade_level_id,
                  kelas: Array.isArray(latestRow?.kelas) ? latestRow.kelas : [],
                },
              ],
            }
          : {};

        const gradeLevels =
          Array.isArray(
            latestDetail?.grade_levels
          )
            ? latestDetail.grade_levels
            : [];

        for (const grade of gradeLevels) {
          /*
           * Pastikan grade level sesuai
           * dengan siswa yang sedang disimpan.
           */
          if (
            saveContext.ysb_grade_level_id &&
            String(
              grade?.ysb_grade_level_id ||
                ""
            ) !==
              String(
                saveContext.ysb_grade_level_id
              )
          ) {
            continue;
          }

          const kelasRows =
            Array.isArray(grade?.kelas)
              ? grade.kelas
              : [];

          for (const kelas of kelasRows) {
            /*
             * Pastikan kelas sesuai.
             */
            if (
              saveContext.ysb_kelas_id &&
              String(
                kelas?.ysb_kelas_id || ""
              ) !==
                String(
                  saveContext.ysb_kelas_id
                )
            ) {
              continue;
            }

            const semesters =
              Array.isArray(
                kelas?.semesters
              )
                ? kelas.semesters
                : [];

            for (
              const semester of semesters
            ) {
              const semesterId =
                semester?.ysb_semester_id ||
                semester?.id ||
                "";

              /*
               * Pastikan semester sesuai.
               *
               * Jadi score_id semester 1 tidak
               * tertukar dengan semester 2.
               */
              if (
                saveContext.ysb_semester_id &&
                String(semesterId) !==
                  String(
                    saveContext.ysb_semester_id
                  )
              ) {
                continue;
              }

              const studentRows =
                Array.isArray(
                  semester?.students
                )
                  ? semester.students
                  : [];

              const foundStudent =
                studentRows.find((item) => {
                  const sameStudentId =
                    saveContext.ysb_student_id &&
                    String(
                      item?.ysb_student_id ||
                        item?.student_id ||
                        item?.id ||
                        ""
                    ) ===
                      String(
                        saveContext.ysb_student_id
                      );

                  const sameEkskulStudentId =
                    saveContext.ysb_ekstrakurikuler_student_id &&
                    String(
                      item?.ysb_ekstrakurikuler_student_id ||
                        ""
                    ) ===
                      String(
                        saveContext.ysb_ekstrakurikuler_student_id
                      );

                  const sameNisn =
                    saveContext.nisn &&
                    String(
                      item?.nisn || ""
                    ) ===
                      String(
                        saveContext.nisn
                      );

                  return (
                    sameStudentId ||
                    sameEkskulStudentId ||
                    sameNisn
                  );
                });

              if (foundStudent) {
                const foundScoreId =
                  getScoreId(foundStudent);

                if (
                  foundScoreId &&
                  foundScoreId !==
                    "default"
                ) {
                  return foundScoreId;
                }
              }
            }
          }
        }
      } catch (error) {
        console.error(
          "Gagal mengambil score_id terbaru:",
          error
        );
      }

      return "";
    };

  /*
   * =========================================================
   * AUTO SAVE KE API
   * =========================================================
   */

  const performAutoSave = async (
    saveContext
  ) => {
    const {
      studentKey,
      inputValue,

      ysb_academic_year_id,
      ysb_semester_id,
      ysb_matpel_id,
      ysb_student_id,
      ysb_branch_id,
      ysb_school_id,
      ysb_grade_level_id,
      ysb_kelas_id,

      user_id,
    } = saveContext;

    if (!ysb_student_id) {
      throw new Error(
        "ID siswa tidak ditemukan"
      );
    }

    if (!ysb_semester_id) {
      throw new Error(
        "Semester tidak ditemukan"
      );
    }

    if (!ysb_matpel_id) {
      throw new Error(
        "ID ekstrakurikuler tidak ditemukan"
      );
    }

    if (!ysb_kelas_id) {
      throw new Error(
        "Kelas tidak ditemukan"
      );
    }

    /*
     * =======================================================
     * TENTUKAN SCORE ID
     * =======================================================
     */

    let scoreId =
      cleanStorageValue(
        scoreIdRef.current[
          studentKey
        ] || inputValue?.score_id
      );

    /*
     * Kondisi ini terjadi kalau CREATE sebelumnya
     * berhasil dikirim tetapi response API tidak
     * memberikan score_id baru.
     *
     * Jangan pernah kembali menggunakan /default.
     * Cari ID baru terlebih dahulu.
     */
    if (
      scoreId ===
      "__resolve_score_id__"
    ) {
      const resolvedScoreId =
        await findCreatedScoreIdFromServer(
          saveContext
        );

      if (!resolvedScoreId) {
        throw new Error(
          "Score ID baru belum ditemukan. Silakan coba input kembali beberapa saat lagi."
        );
      }

      scoreId =
        resolvedScoreId;

      scoreIdRef.current[
        studentKey
      ] = resolvedScoreId;
    }

    if (!scoreId) {
      scoreId = "default";
    }

    /*
     * =======================================================
     * PAYLOAD
     * =======================================================
     */

    const payload = {
      ysb_academic_year_id,
      ysb_semester_id,
      ysb_matpel_id,
      ysb_student_id,
      ysb_branch_id,
      ysb_school_id,
      ysb_grade_level_id,
      ysb_kelas_id,

      date_start:
        inputValue?.date_start || null,

      date_end:
        inputValue?.date_end || null,

      score_mid:
        toApiNumber(
          inputValue?.score_mid
        ),

      predikat_mid:
        toApiNumber(
          inputValue?.predikat_mid
        ),

      comment_mid:
        inputValue?.comment_mid || "",

      score_final:
        toApiNumber(
          inputValue?.score_final
        ),

      predikat_final:
        toApiNumber(
          inputValue?.predikat_final
        ),

      comment_final:
        inputValue?.comment_final || "",

      published: true,

      user_id,
    };

    console.log(
      "AUTO SAVE NILAI EKSKUL",
      {
        student:
          saveContext.nama_lengkap,

        score_id: scoreId,

        url: `/api/ekstrakurikuler-scores/${scoreId}`,

        payload,
      }
    );

    /*
     * =======================================================
     * PUT
     * =======================================================
     *
     * scoreId default:
     * PUT /api/ekstrakurikuler-scores/default
     *
     * scoreId sudah UUID:
     * PUT /api/ekstrakurikuler-scores/{UUID}
     */

    const response =
      await APISD.request({
        method: "PUT",

        url: `/api/ekstrakurikuler-scores/${scoreId}`,

        headers: {
          Authorization: getToken(),
          "Content-Type":
            "application/json",
        },

        data: payload,
      });

    /*
     * =======================================================
     * SETELAH CREATE PERTAMA
     * =======================================================
     */

    if (scoreId === "default") {
      /*
       * Coba ambil ID langsung dari response PUT.
       */
      let newScoreId =
        extractScoreIdFromResponse(
          response
        );

      /*
       * Kalau response PUT tidak membawa score_id,
       * cari dari GET detail terbaru.
       */
      if (!newScoreId) {
        scoreIdRef.current[
          studentKey
        ] = "__resolve_score_id__";

        newScoreId =
          await findCreatedScoreIdFromServer(
            saveContext
          );
      }

      /*
       * Kalau tetap belum ketemu, JANGAN kembalikan
       * score_id menjadi default.
       *
       * Karena kalau kembali default, input berikutnya
       * bisa membuat record baru lagi.
       */
      if (!newScoreId) {
        scoreIdRef.current[
          studentKey
        ] = "__resolve_score_id__";

        throw new Error(
          "Data sudah dikirim, tetapi score ID baru belum ditemukan dari API."
        );
      }

      /*
       * Simpan score_id baru.
       *
       * Input berikutnya akan memakai score_id ini
       * dan otomatis menjadi UPDATE.
       */
      scoreIdRef.current[
        studentKey
      ] = newScoreId;

      /*
       * Update score_id di value form lokal juga.
       */
      const currentInput =
        studentInputsRef.current[
          studentKey
        ];

      if (currentInput) {
        const nextInput = {
          ...currentInput,

          score_id: newScoreId,
        };

        studentInputsRef.current = {
          ...studentInputsRef.current,

          [studentKey]:
            nextInput,
        };

        setStudentInputs((prev) => {
          /*
           * Kalau user keburu pindah kelas,
           * jangan masukkan data siswa lama
           * ke state kelas baru.
           */
          if (!prev[studentKey]) {
            return prev;
          }

          return {
            ...prev,

            [studentKey]: {
              ...prev[studentKey],

              score_id:
                newScoreId,
            },
          };
        });
      }
    }

    return response;
  };

  /*
   * =========================================================
   * QUEUE AUTO SAVE
   * =========================================================
   *
   * Contoh:
   *
   * 1. User pilih tanggal mulai
   *    score_id = default
   *    -> request CREATE
   *
   * 2. Sebelum request pertama selesai,
   *    user pilih tanggal akhir.
   *
   * Request kedua TIDAK langsung jalan.
   * Dia menunggu request pertama selesai.
   *
   * Setelah request pertama mendapat UUID,
   * request kedua memakai UUID tersebut.
   *
   * Jadi tidak ada dua CREATE /default.
   */

  const queueAutoSave = (
    student,
    index
  ) => {
    const studentKey =
      getStudentKey(
        student,
        index
      );

    /*
     * Snapshot value saat field selesai diinput.
     */
    const inputValue = {
      ...(
        studentInputsRef.current[
          studentKey
        ] || {}
      ),
    };

    /*
     * Snapshot semua ID penting saat save.
     *
     * Jadi aman kalau setelah input,
     * user langsung pindah kelas.
     */
    const saveContext = {
      studentKey,
      inputValue,

      ysb_academic_year_id:
        selectedAcademicYearId || "",

      ysb_semester_id:
        activeSemester
          ?.ysb_semester_id ||
        activeSemester?.id ||
        selectedSemesterId ||
        "",

      ysb_matpel_id:
        ekstrakurikulerId,

      ysb_student_id:
        student?.ysb_student_id ||
        student?.student_id ||
        student?.id ||
        "",

      ysb_ekstrakurikuler_student_id:
        student
          ?.ysb_ekstrakurikuler_student_id ||
        "",

      ysb_branch_id:
        getBranchId(),

      ysb_school_id:
        getSchoolId(),

      ysb_grade_level_id:
        selectedKelas
          ?.ysb_grade_level_id ||
        student?.ysb_grade_level_id ||
        "",

      ysb_kelas_id:
        selectedKelas
          ?.ysb_kelas_id ||
        student?.ysb_kelas_id ||
        "",

      user_id:
        getLoginUserId(),

      nisn:
        student?.nisn || "",

      nama_lengkap:
        student?.nama_lengkap || "",
    };

    /*
     * Ambil queue siswa ini.
     */
    const previousQueue =
      saveQueueRef.current[
        studentKey
      ] || Promise.resolve();

    /*
     * Request berikutnya menunggu
     * request sebelumnya selesai.
     */
const nextQueue =
  previousQueue
    .catch(() => {
      /*
       * Jika request sebelumnya gagal,
       * queue berikutnya tetap boleh lanjut.
       */
    })

    .then(async () => {
      await performAutoSave(saveContext);

      /*
       * NOTIF BERHASIL
       */
      ToastError.fire({
        toast: true,
        position: "top-end",

        icon: "success",
        iconColor: "#00c853",

        title: "Nilai berhasil disimpan",

        showConfirmButton: false,

        timer: 2000,
        timerProgressBar: true,

        width: "360px",
      });
    })

    .catch((error) => {
      console.error(
        "AUTO SAVE NILAI EKSKUL ERROR:",
        error
      );

      console.error(
        "AUTO SAVE RESPONSE:",
        error?.response?.data
      );

      /*
       * NOTIF GAGAL
       */
      ToastError.fire({
        toast: true,
        position: "top-end",

        icon: "error",
        iconColor: "#dc3545",

        title:
          error?.response?.data?.message ||
          error?.message ||
          "Gagal menyimpan nilai siswa",

        showConfirmButton: false,

        timer: 2500,
        timerProgressBar: true,

        width: "360px",
      });
    });

saveQueueRef.current[
  studentKey
] = nextQueue;
  };

  /*
   * =========================================================
   * JUMLAH SISWA PER KELAS
   * =========================================================
   */

  const getStudentCountBySemester = (
    kelas
  ) => {
    const semesters = Array.isArray(
      kelas?.semesters
    )
      ? kelas.semesters
      : [];

    const semester =
      semesters.find(
        (item) =>
          String(
            item?.ysb_semester_id ||
              item?.id ||
              ""
          ) ===
          String(
            selectedSemesterId || ""
          )
      );

    return Number(
      semester?.jumlah_siswa ??
        semester?.students?.length ??
        0
    );
  };

  /*
   * =========================================================
   * NAMA SEMESTER
   * =========================================================
   */

  const getSemesterNameByKelas = (
    kelas
  ) => {
    const semesters = Array.isArray(
      kelas?.semesters
    )
      ? kelas.semesters
      : [];

    const semester =
      semesters.find(
        (item) =>
          String(
            item?.ysb_semester_id ||
              item?.id ||
              ""
          ) ===
          String(
            selectedSemesterId || ""
          )
      );

    return (
      semester?.name_semester ||
      semester?.semester ||
      "-"
    );
  };

  const ekskulName =
    detailData?.name_matpel ||
    selectedMatpel?.nama_matpel ||
    "Ekstrakurikuler";

  /*
   * =========================================================
   * RENDER
   * =========================================================
   */

  return (
    <div className={`${embedded ? "" : "body "}nilai-ekskul-tab ${embedded ? "is-embedded" : ""}`.trim()}>
      {/* HEADER */}

      <div className="page-header-card">
        <div className="">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon
                  icon={faBookOpen}
                />
              </span>

              <div>
                <h4 className="page-title-text mb-0">
                  Input Nilai
                </h4>
              </div>
            </div>

            <div className="ml-auto">
              <button
                type="button"
                className="btn btn-light eg-back-button"
                onClick={onBack}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                />{" "}
                Kembali
              </button>
            </div>
          </div>

          <nav
            aria-label="breadcrumb"
            className="custom-breadcrumb-nav mt-4"
          >
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <button
                  type="button"
                  onClick={onBack}
                  style={{
                    background:
                      "transparent",

                    border:
                      "none",

                    padding: 0,

                    margin: 0,

                    color:
                      "#3f5bea",

                    cursor:
                      "pointer",

                    fontSize:
                      "inherit",

                    fontWeight: 500,
                  }}
                >
                  Ekstrakurikuler
                </button>
              </li>

              <li className="custom-breadcrumb-separator">
                /
              </li>

              <li
                className="custom-breadcrumb-item active"
                aria-current="page"
              >
                {selectedMatpel
                  ?.nama_matpel ||
                  "Ekstrakurikuler"}
                {" - "}
                Kelas{" "}
                {selectedMatpel
                  ?.name_level ||
                  "-"}
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* CONTENT */}

      {/* <div className="body-content"> */}
        {isFetching ? (
          <div className="eg-loading-wrap">
            <PulseLoader
              color="#3f5bea"
              size={10}
            />
          </div>
        ) : (
          <>
            {/* INFO EKSTRAKURIKULER */}

            <div className="eg-info-card">
              <div className="eg-info-block">
                <span className="eg-info-icon">
                  <FontAwesomeIcon
                    icon={faBookOpen}
                  />
                </span>

                <div>
                  <div className="eg-info-label">
                    Ekstrakurikuler 
                  </div>

                  <div className="eg-info-value">
                    {ekskulName}
                  </div>
                </div>
              </div>

              <div className="eg-info-divider" />

              <div className="eg-info-block">
                <span className="eg-info-icon">
                  <FontAwesomeIcon
                    icon={faUser}
                  />
                </span>

                <div>
                  <div className="eg-info-label">
                    Pembina
                  </div>

                  {/* <div className="eg-info-value">
                    {pembinaName}
                  </div> */}

                  <div className="eg-pembina-list">
                    {pembinaList.length > 0 ? (
                      pembinaList.map((nama, index) => (
                        <div
                          key={`${nama}-${index}`}
                          className="eg-pembina-item"
                        >
                          <span className="eg-pembina-number">
                            {index + 1}
                          </span>

                          <span className="eg-pembina-name">
                            {nama}
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className="eg-info-value">
                        -
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* PILIH KELAS */}

            {kelasList.length > 0 ? (
              <>
                {/* CARD KELAS - disamakan dengan tab Pembina & Siswa */}

                <div className="cm-class-grid">
                  {kelasList.map((kelas, index) => {
                    const kelasId = kelas?.ysb_kelas_id || "";
                    const isActive =
                      String(kelasId) ===
                      String(selectedKelas?.ysb_kelas_id || "");

                    const rawTitle = [
                      kelas?.name_level,
                      formatClassText(kelas?.name_kelas),
                    ]
                      .filter(Boolean)
                      .join(" ")
                      .trim();

                    const classTitle = String(rawTitle || "-")
                      .toLowerCase()
                      .startsWith("kelas")
                      ? formatClassText(rawTitle)
                      : `Kelas ${rawTitle || "-"}`;

                    const classSemesters =
                      semesterOptions.length > 0
                        ? semesterOptions
                        : Array.isArray(kelas?.semesters)
                        ? kelas.semesters
                        : [];

                    return (
                      <button
                        type="button"
                        key={`nilai-class-card-${kelasId}-${index}`}
                        className={`cm-class-card ${
                          isActive ? "is-active" : ""
                        }`}
                        onClick={() => setSelectedKelasId(kelasId)}
                      >
                        <div className="cm-class-card-top">
                          <span className="cm-class-icon">
                            <FontAwesomeIcon icon={faChalkboardTeacher} />
                          </span>

                          <span>
                            <span className="cm-class-name">
                              {classTitle}
                            </span>
                            <span className="cm-class-meta">
                              1 ekstrakurikuler
                            </span>
                          </span>
                        </div>

                        <div className="cm-class-semesters">
                          {classSemesters.map((semesterItem, semesterIndex) => {
                            const semesterId =
                              semesterItem?.id ||
                              semesterItem?.ysb_semester_id ||
                              `semester-${semesterIndex + 1}`;
                            const semesterNumber =
                              semesterItem?.semester ||
                              semesterItem?.name_semester ||
                              semesterIndex + 1;

                            return (
                              <span
                                key={`nilai-mini-semester-${kelasId}-${semesterId}`}
                                className="cm-mini-chip"
                              >
                                Semester {semesterNumber}
                              </span>
                            );
                          })}
                        </div>
                      </button>
                    );
                  })}
                </div>

                {/* TABLE */}

                <div className="cm-context-card nilai-score-context">
                  <div className="cm-context-head nilai-score-context-head">
                    <div className="cm-context-title">
                      <h5 className="eg-table-title">
                        Kelas{" "}
                        {selectedKelas
                          ?.name_level ||
                          "-"}{" "}
                        {formatClassText(
                          selectedKelas?.name_kelas
                        )}{" "}
                        - Semester{" "}
                        {activeSemester
                          ?.name_semester ||
                          "-"}
                      </h5>
                    </div>

                    {semesterOptions.length > 0 && (
                      <div className="cm-semester-switch nilai-semester-switch" role="tablist" aria-label="Semester nilai">
                        {semesterOptions.map((semesterItem, semesterIndex) => {
                          const semesterId =
                            semesterItem?.id ||
                            semesterItem?.ysb_semester_id ||
                            "";
                          const semesterNumber =
                            semesterItem?.semester ||
                            semesterItem?.name_semester ||
                            semesterIndex + 1;

                          return (
                            <button
                              type="button"
                              key={`nilai-semester-${semesterId || semesterIndex}`}
                              className={`cm-semester-button nilai-semester-button ${
                                String(semesterId) === String(selectedSemesterId)
                                  ? "is-active"
                                  : ""
                              }`}
                              onClick={() =>
                                typeof onSemesterChange === "function" &&
                                onSemesterChange(semesterItem)
                              }
                            >
                              Semester {semesterNumber}
                            </button>
                          );
                        })}
                      </div>
                    )}

                    {/* <div className="eg-total-badge">
                      <FontAwesomeIcon
                        icon={faUsers}
                      />{" "}
                      {students.length}{" "}
                      siswa 1
                    </div> */}
                  </div>

                  <div className="cm-table-wrap eg-table-responsive nilai-score-table-wrap">
                    <table className="cm-table eg-student-table nilai-score-table">
                      <thead>
                        <tr>
                          <th className="eg-col-no">
                            No 
                          </th>

                          <th className="eg-col-student">
                            Nama Siswa
                          </th>

                          <th className="eg-col-nisn">
                            NISN
                          </th>

                          <th className="eg-col-date">
                            Tanggal Mulai
                          </th>

                          <th className="eg-col-date">
                            Tanggal Akhir
                          </th>

                          <th className="eg-col-score">
                            Nilai Mid
                            Semester
                          </th>

                          <th className="eg-col-predicate">
                            Nilai Predikat
                            Mid Semester
                          </th>

                          <th className="eg-col-comment">
                            Komentar Mid
                            Semester
                          </th>

                          <th className="eg-col-score">
                            Nilai Akhir
                            Semester
                          </th>

                          <th className="eg-col-predicate">
                            Nilai Predikat
                            Akhir Semester
                          </th>

                          <th className="eg-col-comment">
                            Komentar Akhir
                            Semester
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {students.length >
                        0 ? (
                          students.map(
                            (
                              student,
                              index
                            ) => {
                              const studentKey =
                                getStudentKey(
                                  student,
                                  index
                                );

                              const inputValue =
                                studentInputs[
                                  studentKey
                                ] || {
                                  score_id:
                                    getScoreId(
                                      student
                                    ),

                                  date_start:
                                    "",

                                  date_end:
                                    "",

                                  score_mid:
                                    "",

                                  predikat_mid:
                                    "",

                                  comment_mid:
                                    "",

                                  score_final:
                                    "",

                                  predikat_final:
                                    "",

                                  comment_final:
                                    "",
                                };

                              return (
                                <tr
                                  key={
                                    studentKey
                                  }
                                >
                                  {/* NOMOR */}

                                  <td className="eg-col-no">
                                    <span className="eg-number-badge">
                                      {index +
                                        1}
                                    </span>
                                  </td>

                                  {/* NAMA SISWA */}

                                  <td className="eg-student-name">
                                    {student
                                      ?.nama_lengkap ||
                                      "-"}
                                  </td>

                                  {/* NISN */}

                                  <td className="eg-student-nisn">
                                    {student
                                      ?.nisn ||
                                      "-"}
                                  </td>

                                  {/* TANGGAL MULAI */}

                                  <td>
                                    <input
                                      type="date"
                                      className="eg-table-input eg-date-input"
                                      value={
                                        inputValue.date_start
                                      }
                                      onChange={(
                                        e
                                      ) => {
                                        /*
                                         * Update form lokal dahulu.
                                         */
                                        handleStudentInputChange(
                                          studentKey,
                                          "date_start",
                                          e
                                            .target
                                            .value
                                        );

                                        /*
                                         * Date langsung save
                                         * saat tanggal dipilih.
                                         */
                                        queueAutoSave(
                                          student,
                                          index
                                        );
                                      }}
                                    />
                                  </td>

                                  {/* TANGGAL AKHIR */}

                                  <td>
                                    <input
                                      type="date"
                                      className="eg-table-input eg-date-input"
                                      value={
                                        inputValue.date_end
                                      }
                                      onChange={(
                                        e
                                      ) => {
                                        handleStudentInputChange(
                                          studentKey,
                                          "date_end",
                                          e
                                            .target
                                            .value
                                        );

                                        queueAutoSave(
                                          student,
                                          index
                                        );
                                      }}
                                    />
                                  </td>

                                  {/* NILAI MID */}

                                  <td>
                                    <input
                                      type="number"
                                      step="any"
                                      className="eg-table-input eg-score-input"
                                      value={
                                        inputValue.score_mid
                                      }
                                      onChange={(
                                        e
                                      ) =>
                                        handleStudentInputChange(
                                          studentKey,
                                          "score_mid",
                                          e
                                            .target
                                            .value
                                        )
                                      }
                                      onBlur={() =>
                                        queueAutoSave(
                                          student,
                                          index
                                        )
                                      }
                                      placeholder="Nilai"
                                    />
                                  </td>

                                  {/* PREDIKAT MID */}

                                  <td>
                                    -
                                    {/* <input
                                      type="text"
                                      className="eg-table-input eg-predicate-input"
                                      value={
                                        inputValue.predikat_mid
                                      }
                                      onChange={(
                                        e
                                      ) =>
                                        handleStudentInputChange(
                                          studentKey,
                                          "predikat_mid",
                                          e
                                            .target
                                            .value
                                        )
                                      }
                                      onBlur={() =>
                                        queueAutoSave(
                                          student,
                                          index
                                        )
                                      }
                                      placeholder="Predikat"
                                    /> */}
                                  </td>

                                  {/* KOMENTAR MID */}

                                  <td>
                                    <textarea
                                      className="eg-table-input eg-comment-input"
                                      rows="2"
                                      value={
                                        inputValue.comment_mid
                                      }
                                      onChange={(
                                        e
                                      ) =>
                                        handleStudentInputChange(
                                          studentKey,
                                          "comment_mid",
                                          e
                                            .target
                                            .value
                                        )
                                      }
                                      onBlur={() =>
                                        queueAutoSave(
                                          student,
                                          index
                                        )
                                      }
                                      placeholder="Tulis komentar..."
                                    />
                                  </td>

                                  {/* NILAI FINAL */}

                                  <td>
                                    <input
                                      type="number"
                                      step="any"
                                      className="eg-table-input eg-score-input"
                                      value={
                                        inputValue.score_final
                                      }
                                      onChange={(
                                        e
                                      ) =>
                                        handleStudentInputChange(
                                          studentKey,
                                          "score_final",
                                          e
                                            .target
                                            .value
                                        )
                                      }
                                      onBlur={() =>
                                        queueAutoSave(
                                          student,
                                          index
                                        )
                                      }
                                      placeholder="Nilai"
                                    />
                                  </td>

                                  {/* PREDIKAT FINAL */}

                                  <td>
                                    -
                                    {/* <input
                                      type="text"
                                      className="eg-table-input eg-predicate-input"
                                      value={
                                        inputValue.predikat_final
                                      }
                                      onChange={(
                                        e
                                      ) =>
                                        handleStudentInputChange(
                                          studentKey,
                                          "predikat_final",
                                          e
                                            .target
                                            .value
                                        )
                                      }
                                      onBlur={() =>
                                        queueAutoSave(
                                          student,
                                          index
                                        )
                                      }
                                      placeholder="Predikat"
                                    /> */}
                                    {/* predikat */}
                                  </td>

                                  {/* KOMENTAR FINAL */}

                                  <td>
                                    <textarea
                                      className="eg-table-input eg-comment-input"
                                      rows="2"
                                      value={
                                        inputValue.comment_final
                                      }
                                      onChange={(
                                        e
                                      ) =>
                                        handleStudentInputChange(
                                          studentKey,
                                          "comment_final",
                                          e
                                            .target
                                            .value
                                        )
                                      }
                                      onBlur={() =>
                                        queueAutoSave(
                                          student,
                                          index
                                        )
                                      }
                                      placeholder="Tulis komentar..."
                                    />
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : (
                          <tr>
                            <td colSpan="11">
                              <div className="eg-empty-state">
                                <span className="eg-empty-icon">
                                  <FontAwesomeIcon
                                    icon={
                                      faChalkboardTeacher
                                    }
                                  />
                                </span>

                                <div>
                                  Belum ada
                                  siswa pada
                                  kelas dan
                                  semester ini.
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            ) : (
              <div className="eg-empty-card">
                <FontAwesomeIcon
                  icon={
                    faChalkboardTeacher
                  }
                />

                <span>
                  Belum ada data kelas
                  untuk ekstrakurikuler
                  ini.
                </span>
              </div>
            )}
          </>
        )}
      </div>
    // </div>
  );
}

export default function ConfigEkskul() {
  document.title = "Konfigurasi Ekstrakurikuler";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);

  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem("ysb_school_id");

  // SEARCH
  const [searchMap, setSearchMap] = useState({});

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [loadingLevel, setLoadingLevel] = useState(false);

  const [headerKelas, setHeaderKelas] = useState([]);
  const [activeKelasId, setActiveKelasId] = useState("");
  const [activeSemester, setActiveSemester] = useState(1);

  // Table data
  const [getData, setGetData] = useState([]);
  const [getDataPembina, setGetDataPembina] = useState([]);
  const [getDataSiswa, setGetDataSiswa] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  /* modal */
  const [id, setId] = useState();
  const [nameUpdate, setNameUpdate] = useState();
  const [updateData, setUpdateData] = useState(null);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const [getDataAcademicYear, setGetDataAcademicYear] = useState([]);
  const [getAllSemester, setGetAllSemester] = useState([]);

  const [searchKeyword, setSearchKeyword] = useState("");

  // =========================
  // MODAL TAMBAH GURU - AMBIL DARI ENDPOINT HRIS
  // =========================
  const [teachers, setTeachers] = useState([]);
  const [loadingTeachers, setLoadingTeachers] = useState(false);
  // const [savingTeacherConfig, setSavingTeacherConfig] = useState(false);

  const [modalTambahGuru, setModalTambahGuru] = useState(false);
  const [selectedMatpelRow, setSelectedMatpelRow] = useState(null);
  // const [selectedKelasSemester, setSelectedKelasSemester] = useState({});
  // const [selectedGuruIds, setSelectedGuruIds] = useState([]);
  const [guruMap, setGuruMap] = useState({});

  const [modalUpdateGuru, setModalUpdateGuru] = useState(false);
  const [selectedUpdateGuruRow, setSelectedUpdateGuruRow] = useState(null);

  // TAB PEMBINA / SISWA / NILAI
  const [activeConfigTab, setActiveConfigTab] = useState("pembina");
  const activeConfigTabRef = useRef("pembina");

  // NILAI
  const [nilaiEkskulId, setNilaiEkskulId] = useState("");
  const [nilaiSemesterId, setNilaiSemesterId] = useState("");
  const [nilaiStudentSearch, setNilaiStudentSearch] = useState("");
  const [nilaiScoreRows, setNilaiScoreRows] = useState([]);

  // Cache data tabel Nilai. GET dijalankan dari Home sejak halaman dimuat,
  // bukan saat user baru menekan tab Nilai.
  const [nilaiScoreCache, setNilaiScoreCache] = useState({});

  // SISWA
  const [modalTambahSiswa, setModalTambahSiswa] = useState(false);
  const [selectedStudentRow, setSelectedStudentRow] = useState(null);
  const [studentMap, setStudentMap] = useState({});
  const [studentSearchKeyword, setStudentSearchKeyword] = useState("");

  // MODAL DAFTAR SISWA
  const [modalDaftarSiswa, setModalDaftarSiswa] = useState(false);
  const [selectedStudentList, setSelectedStudentList] = useState(null);

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
  });

  const [updateId, setUpdateID] = useState(null);

  const [scorePicker, setScorePicker] = useState({
    open: false,
    recapId: null,
    top: 0,
    left: 0,
    meta: null,
  });

  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // =========================
  // Fetch guru 
  // =========================
  const fetchTeachersByFilter = useCallback(
    async (branchId, schoolId) => {
      if (!branchId || !schoolId) {
        setTeachers([]);
        return;
      }

      setLoadingTeachers(true);

      try {

        const res = await APISM.get(
          `/api/access/teachers?page=1&limit=100&ascending=0&search=&ascending_name=true&ysb_school_id=${schoolId}`,
          fetchParams
        );

        const rows = res?.data?.data || [];

        const mappedTeachers = rows
          .map((item) => ({
            id:
              item?.id ||
              item?.user_id ||
              item?.teacher_id ||
              item?.ysb_teacher_id ||
              "",
            name:
              item?.full_name ||
              item?.name ||
              item?.teacher_name ||
              item?.nama_lengkap ||
              "-",
            nik:
              item?.nik_ysb ||
              item?.nip_ypi ||
              item?.nip_ypi_karyawan ||
              item?.nik ||
              "",
            branch: item?.ysb_branch_id || branchId,
            school: item?.ysb_school_id || schoolId,
            photo: item?.photo || item?.image || item?.foto || null,
            raw: item,
          }))
          .filter((item) => item.id && item.name && item.name !== "-")
          .sort((a, b) =>
            String(a.name).localeCompare(String(b.name), "id", {
              numeric: true,
              sensitivity: "base",
            })
          );

        setTeachers(mappedTeachers);
      } catch (err) {
        console.error("Gagal mengambil data pembina", err);
        setTeachers([]);

        ToastError.fire({
          icon: "error",
          title:
            err?.response?.data?.message ||
            "Gagal mengambil data pembina berdasarkan sekolah",
        });
      } finally {
        setLoadingTeachers(false);
      }
    },
    [fetchParams]
  );


  useEffect(() => {
    if (form2.ysb_branch_id && form2.ysb_school_id) {
      fetchTeachersByFilter(form2.ysb_branch_id, form2.ysb_school_id);
    } else {
      setTeachers([]);
    }

    // reset pilihan guru ketika filter cabang/sekolah berubah
    // setSelectedGuruIds([]);
  }, [form2.ysb_branch_id, form2.ysb_school_id, fetchTeachersByFilter]);

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const collator = useMemo(
    () => new Intl.Collator("id", { numeric: true, sensitivity: "base" }),
    []
  );

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // SORT sekolah: SD → SMP → SMA
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) =>
        (a.school_name || "").toUpperCase().includes(j)
      );
      const jenjangB = order.findIndex((j) =>
        (b.school_name || "").toUpperCase().includes(j)
      );
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") {
      return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    }
    return schools;
  };

  const getSemesterByAcademicYear = useCallback((academicYearId, semesters = getAllSemester) => {
    return (semesters || [])
      .filter(
        (item) =>
          String(item?.ysb_academic_year_id) === String(academicYearId)
      )
      .sort((a, b) => Number(a?.semester || 0) - Number(b?.semester || 0));
  }, [getAllSemester]);

  // =========================
  // INIT: Branch, Tahun Akademik
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [academicYearRes, semesterRes, branchRes] = await Promise.all([
        APIMS.get(`/api/academic-years`, {
          ...fetchParams,
          signal: controller.signal,
          params: {
            page,
            limit: 10,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
          data: {
            page,
            limit: 10,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
        }),

        APIMS.get(`/api/semesters`, {
          ...fetchParams,
          signal: controller.signal,
          params: {
            page,
            limit: 10,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
          data: {
            page,
            limit: 10,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
        }),

        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      if (academicYearRes?.status === 200) {
        const academicYears = academicYearRes?.data?.data || [];

        const activeAcademicYear =
          academicYears.find(
            (item) =>
              item?.status === 1 ||
              item?.status === "1" ||
              item?.is_active === 1 ||
              item?.is_active === true
          ) || academicYears[0];

        setGetDataAcademicYear(academicYears);

        if (activeAcademicYear) {
          setNamaTA(activeAcademicYear?.name_year || activeAcademicYear?.name || "");

          setForm2((prev) => ({
            ...prev,
            // ini tetap academic year id ya
            ysb_semester_id: activeAcademicYear?.id || "",
          }));

          const semesterRows = semesterRes?.data?.data || [];
          setGetAllSemester(semesterRows);

          const semestersByActiveYear = semesterRows
            .filter(
              (item) =>
                String(item?.ysb_academic_year_id) ===
                String(activeAcademicYear?.id)
            )
            .sort((a, b) => Number(a?.semester || 0) - Number(b?.semester || 0));

          setGetDataSemesterMap(semestersByActiveYear);
        }
      }

      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);

        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;
          setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
        }
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    }
  }, [
    ascending,
    fetchParams,
    keyword,
    limit,
    page,
    storageBranchGroping,
    storageLevel,
  ]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      setLoadingSchool(true);

      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let schools = res.data.data || [];

          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter((s) => s.ysb_branch_id === branchId);
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          if (schools.length > 0) {
            setGetDataLevel([]);

            setForm2((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
              ysb_grade_level_id: "",
            }));
          } else {
            setGetDataLevel([]);
            setForm2((prev) => ({
              ...prev,
              ysb_school_id: "",
              ysb_grade_level_id: "",
            }));
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        initSchoolDone.current = true;
        setLoadingSchool(false);
        setLoading(false);
      }
    },
    [ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);

  // =========================
  // Fetch tingkatan saat sekolah berubah
  // =========================
  const sortLevels = (levels) => {
    return [...levels].sort((a, b) =>
      (a?.name_level || "").localeCompare(b?.name_level || "", "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const sortKelas = (kelas) => {
    return [...kelas].sort((a, b) =>
      (a?.name_kelas || "").localeCompare(b?.name_kelas || "", "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      initLevelDone.current = false;

      if (!schoolId) return;

      setLoadingLevel(true);

      try {
        const res = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let levels = res.data?.data || [];

          levels = levels.filter((x) => x?.ysb_school_id === schoolId);
          if (branchId) {
            levels = levels.filter((x) => x?.ysb_branch_id === branchId);
          }

          levels = sortLevels(levels);
          setGetDataLevel(levels);

          if (levels.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: levels[0].id,
            }));
          } else {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: "",
            }));
          }
        }
      } catch (err) {
        console.error(err);
        swal({
          title: "Failed",
          text:
            err?.response?.data?.message ||
            err.message ||
            "Gagal mengambil data tingkatan",
          icon: "error",
          timer: 3000,
          buttons: false,
        });

        setGetDataLevel([]);
        setForm2((prev) => ({ ...prev, ysb_grade_level_id: "" }));
      } finally {
        initLevelDone.current = true;
        setLoadingLevel(false);
      }
    },
    [fetchParams, page, limit, ascending, storageLevel]
  );

  useEffect(() => {
    if (!form2.ysb_school_id) {
      setGetDataLevel([]);
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "" }));
      return;
    }

    setGetDataLevel([]);
    setForm2((prev) => ({ ...prev, ysb_grade_level_id: "" }));
    fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
  }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !loadingLevel &&
    (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

  const buildEditingMap = (rows) => {
    const nextMap = {};
    (rows || []).forEach((item) => {
      (item?.data_school || []).forEach((school) => {
        const key = `${item?.ysb_sub_element_id}__${school?.ysb_school_id}`;
        nextMap[key] = school?.ysb_sub_element_value ?? "";
      });
    });
    return nextMap;
  };

  const buildKelasTabsFromMatpels = (rows, gradeLevelId) => {
    const map = new Map();

    (rows || []).forEach((matpel) => {
      (matpel?.grade_levels || []).forEach((level) => {
        if (String(level?.ysb_grade_level_id) !== String(gradeLevelId)) return;

        const nameLevel = level?.name_level || "";

        (level?.kelas || []).forEach((kelas) => {
          const kelasId = kelas?.ysb_kelas_id;
          if (!kelasId) return;

          const nameKelas = kelas?.name_kelas || "";
          const title = [nameLevel, nameKelas].filter(Boolean).join(" ");

          if (!map.has(kelasId)) {
            map.set(kelasId, {
              ysb_kelas_id: kelasId,
              ysb_grade_level_id: level?.ysb_grade_level_id || "",
              name_level: nameLevel,
              name_kelas: nameKelas,
              title: title || kelasId,
              ysb_school_id: kelas?.ysb_school_id || "",
              state_form: kelas?.state_form ?? "",
            });
          }
        });
      });
    });

    return Array.from(map.values()).sort((a, b) =>
      String(a?.title || "").localeCompare(String(b?.title || ""), "id", {
        numeric: true,
        sensitivity: "base",
      })
    );
  };

  const isMatpelInKelas = (matpel, gradeLevelId, kelasId) => {
    return (matpel?.grade_levels || []).some((level) => {
      if (String(level?.ysb_grade_level_id) !== String(gradeLevelId)) {
        return false;
      }

      return (level?.kelas || []).some(
        (kelas) => String(kelas?.ysb_kelas_id) === String(kelasId)
      );
    });
  };

  const mergeMatpelKelas = (oldRow, newRow) => {
    const oldLevels = oldRow?.grade_levels || [];
    const newLevels = newRow?.grade_levels || [];

    const levelMap = new Map();

    oldLevels.forEach((level) => {
      levelMap.set(String(level?.ysb_grade_level_id), {
        ...level,
        kelas: [...(level?.kelas || [])],
      });
    });

    newLevels.forEach((newLevel) => {
      const key = String(newLevel?.ysb_grade_level_id);
      const existingLevel = levelMap.get(key);

      if (!existingLevel) {
        levelMap.set(key, {
          ...newLevel,
          kelas: [...(newLevel?.kelas || [])],
        });
        return;
      }

      const kelasMap = new Map(
        (existingLevel?.kelas || []).map((kelas) => [
          String(kelas?.ysb_kelas_id),
          kelas,
        ])
      );

      (newLevel?.kelas || []).forEach((kelas) => {
        kelasMap.set(String(kelas?.ysb_kelas_id), kelas);
      });

      levelMap.set(key, {
        ...existingLevel,
        kelas: Array.from(kelasMap.values()),
      });
    });

    return {
      ...oldRow,
      ...newRow,
      id: oldRow?.id || newRow?.id,
      grade_levels: Array.from(levelMap.values()),
    };
  };

  const handleAddDummyConfig = useCallback(
    (dummyRow) => {
      setGetData((prev) => {
        const prevRows = Array.isArray(prev) ? prev : [];

        const existingIndex = prevRows.findIndex(
          (item) =>
            String(item?.ysb_matpel_id || item?.id) ===
            String(dummyRow?.ysb_matpel_id || dummyRow?.id)
        );

        let nextRows = [];

        if (existingIndex >= 0) {
          nextRows = [...prevRows];
          nextRows[existingIndex] = mergeMatpelKelas(
            nextRows[existingIndex],
            dummyRow
          );
        } else {
          nextRows = [dummyRow, ...prevRows];
        }

        const kelasTabs = buildKelasTabsFromMatpels(
          nextRows,
          form2.ysb_grade_level_id
        );

        setHeaderKelas(kelasTabs);

        setActiveKelasId((prevActiveKelasId) => {
          const stillExists = kelasTabs.some(
            (item) =>
              String(item?.ysb_kelas_id) === String(prevActiveKelasId)
          );

          if (prevActiveKelasId && stillExists) {
            return prevActiveKelasId;
          }

          return kelasTabs?.[0]?.ysb_kelas_id || "";
        });

        return nextRows;
      });

      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);

      ToastSuccess.fire({
        icon: "success",
        title: "Konfigurasi ekstrakurikuler berhasil ditambahkan",
      });
    },
    [form2.ysb_grade_level_id]
  );

  const handleUpdateMatpel = (row) => {
    swal({
      title: "Update Ekstrakurikuler",
      text: `Update untuk ${
        row?.name_matpel || "-"
      } siap dihubungkan ke modal/form update.`,
      icon: "info",
    });
  };

  const handleDeleteMatpel = (row) => {
    swal({
      title: "Hapus Ekstrakurikuler?",
      text: `Yakin ingin menghapus ${row?.name_matpel || "-"}?`,
      icon: "warning",
      buttons: ["Batal", "Hapus"],
      dangerMode: true,
    }).then((willDelete) => {
      if (!willDelete) return;
      console.log("delete matpel:", row);
    });
  };

  // =========================
  // GET TABLE CONFIG MATPEL
  // =========================
  // const GetResponseData = useCallback(async () => {
  //   if (
  //     !form2.ysb_semester_id ||
  //     !form2.ysb_branch_id ||
  //     !form2.ysb_school_id ||
  //     !form2.ysb_grade_level_id
  //   ) {
  //     return;
  //   }

  //   setIsFetching(true);

  //   try {
  //     const response = await APISD.get(`/api/ekstrakurikuler-configs`, {
  //       ...fetchParams,
  //       params: {
  //         page: 1,
  //         limit: 10000,
  //         ascending: true,
  //         ysb_branch_id: form2.ysb_branch_id,
  //         ysb_school_id: form2.ysb_school_id,
  //         ysb_grade_level_id: form2.ysb_grade_level_id,
  //       },

  //       data: {
  //         page: 1,
  //         limit: 10000,
  //         ascending: true,
  //         ysb_branch_id: form2.ysb_branch_id,
  //         ysb_school_id: form2.ysb_school_id,
  //         ysb_grade_level_id: form2.ysb_grade_level_id,
  //       },
  //     });

  //     if (response?.status === 200) {
  //       const rows = response?.data?.data || [];

  //       const kelasTabs = buildKelasTabsFromMatpels(
  //         rows,
  //         form2.ysb_grade_level_id
  //       );

  //       setGetData(rows);
  //       setHeaderKelas(kelasTabs);

  //       setActiveKelasId((prevActiveKelasId) => {
  //         const stillExists = kelasTabs.some(
  //           (item) =>
  //             String(item?.ysb_kelas_id) === String(prevActiveKelasId)
  //         );

  //         if (prevActiveKelasId && stillExists) {
  //           return prevActiveKelasId;
  //         }

  //         return kelasTabs?.[0]?.ysb_kelas_id || "";
  //       });

  //       setHasSearched(true);
  //       setIsFirstLoad(false);
  //       setIsFilterDirty(false);
  //     }
  //   } catch (error) {
  //     console.log("Gagal mengambil data ekstrakurikuler", error);
  //     setGetData([]);
  //     setHeaderKelas([]);
  //     setActiveKelasId("");
  //     setHasSearched(true);
  //   } finally {
  //     setIsFetching(false);
  //   }
  // }, [
  //   fetchParams,
  //   form2.ysb_semester_id,
  //   form2.ysb_branch_id,
  //   form2.ysb_school_id,
  //   form2.ysb_grade_level_id,
  // ]);

  // =========================
// GET TABLE CONFIG EKSTRAKURIKULER
// =========================
// Sekali proses GET mengambil data untuk kedua tab.
// Setelah itu perpindahan Pembina <-> Siswa hanya
// memakai cache state, jadi tidak memanggil API lagi.
// =========================
const GetResponseData = useCallback(async () => {
  if (
    !form2.ysb_semester_id ||
    !form2.ysb_branch_id ||
    !form2.ysb_school_id ||
    !form2.ysb_grade_level_id
  ) {
    return;
  }

  // Setiap refresh filter/config, cache nilai ikut di-reset supaya
  // data yang diprefetch selalu mengikuti pilihan terbaru.
  setNilaiScoreCache({});

  setIsFetching(true);

  const payload = {
    page: 1,
    limit: 10000,
    ascending: true,
    ysb_branch_id: form2.ysb_branch_id,
    ysb_school_id: form2.ysb_school_id,
    ysb_grade_level_id: form2.ysb_grade_level_id,
  };

  try {
    const [pembinaResult, siswaResult, nilaiResult] = await Promise.allSettled([
      APISD.get(`/api/ekstrakurikuler-configs`, {
        ...fetchParams,
        params: payload,
        data: payload,
      }),
      APISD.get(`/api/ekstrakurikuler-students/student-config`, {
        ...fetchParams,
        params: payload,
        data: payload,
      }),
      APISD.get(`/api/ekstrakurikuler-scores`, {
        ...fetchParams,
        params: {
          ysb_academic_year_id: form2.ysb_semester_id,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
          ysb_grade_level_id: form2.ysb_grade_level_id,
        },
        data: {
          ysb_academic_year_id: form2.ysb_semester_id,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
          ysb_grade_level_id: form2.ysb_grade_level_id,
        },
      }),
    ]);

    const pembinaResponse =
      pembinaResult.status === "fulfilled" ? pembinaResult.value : null;
    const siswaResponse =
      siswaResult.status === "fulfilled" ? siswaResult.value : null;
    const nilaiResponse =
      nilaiResult.status === "fulfilled" ? nilaiResult.value : null;

    if (pembinaResult.status === "rejected") {
      console.error(
        "Gagal mengambil konfigurasi pembina ekstrakurikuler",
        pembinaResult.reason
      );
    }

    if (siswaResult.status === "rejected") {
      console.error(
        "Gagal mengambil konfigurasi siswa ekstrakurikuler",
        siswaResult.reason
      );
    }

    if (nilaiResult.status === "rejected") {
      console.error("Gagal mengambil nilai ekstrakurikuler", nilaiResult.reason);
    }

    const pembinaRows =
      pembinaResponse?.status === 200
        ? pembinaResponse?.data?.data || []
        : [];

    let siswaRows =
      siswaResponse?.status === 200
        ? siswaResponse?.data?.data || []
        : [];

    const nilaiRows =
      nilaiResponse?.status === 200 && Array.isArray(nilaiResponse?.data?.data)
        ? nilaiResponse.data.data
        : [];

    if (!pembinaResponse && !siswaResponse) {
      throw pembinaResult.reason || siswaResult.reason || new Error(
        "Gagal mengambil data konfigurasi ekstrakurikuler"
      );
    }

    // Endpoint student-config tidak menerima academic year pada payload,
    // jadi hasilnya disaring berdasarkan Tahun Ajaran yang sedang dipilih.
    if (form2.ysb_semester_id) {
      siswaRows = siswaRows.filter(
        (item) =>
          !item?.ysb_academic_year_id ||
          String(item?.ysb_academic_year_id) ===
            String(form2.ysb_semester_id)
      );
    }

    setGetDataPembina(pembinaRows);
    setGetDataSiswa(siswaRows);
    setNilaiScoreRows(nilaiRows);

    // Bentuk endpoint baru langsung berisi kelas -> semesters -> students.
    // Ubah menjadi bentuk detail lama agar komponen tabel tetap dapat dipakai.
    const nextNilaiCache = {};
    nilaiRows.forEach((row) => {
      const ekskulId = row?.ysb_matpel_id || row?.id || "";
      if (!ekskulId) return;

      const cacheKey = [
        ekskulId,
        form2.ysb_semester_id,
        form2.ysb_branch_id,
        form2.ysb_school_id,
      ].join("|");

      nextNilaiCache[cacheKey] = {
        ...row,
        grade_levels: [
          {
            ysb_grade_level_id: form2.ysb_grade_level_id,
            kelas: Array.isArray(row?.kelas) ? row.kelas : [],
          },
        ],
      };
    });
    setNilaiScoreCache(nextNilaiCache);

    const currentRows =
      activeConfigTabRef.current === "siswa" ? siswaRows : pembinaRows;

    const kelasTabs = buildKelasTabsFromMatpels(
      currentRows,
      form2.ysb_grade_level_id
    );

    setGetData(currentRows);
    setHeaderKelas(kelasTabs);

    setActiveKelasId((prevActiveKelasId) => {
      const stillExists = kelasTabs.some(
        (item) =>
          String(item?.ysb_kelas_id) === String(prevActiveKelasId)
      );

      if (prevActiveKelasId && stillExists) {
        return prevActiveKelasId;
      }

      return kelasTabs?.[0]?.ysb_kelas_id || "";
    });

    setHasSearched(true);
    setIsFirstLoad(false);
    setIsFilterDirty(false);
  } catch (error) {
    console.log("Gagal mengambil data konfigurasi ekstrakurikuler", error);

    setGetDataPembina([]);
    setGetDataSiswa([]);
    setNilaiScoreRows([]);
    setGetData([]);
    setHeaderKelas([]);
    setActiveKelasId("");
    setHasSearched(true);

    ToastError.fire({
      icon: "error",
      title:
        error?.response?.data?.message ||
        "Gagal mengambil data konfigurasi ekstrakurikuler",
    });
  } finally {
    setIsFetching(false);
  }
}, [
  fetchParams,
  form2.ysb_semester_id,
  form2.ysb_branch_id,
  form2.ysb_school_id,
  form2.ysb_grade_level_id,
]);

  useEffect(() => {
    if (
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id ||
      loadingSchool ||
      loadingLevel
    ) {
      return;
    }

    GetResponseData();
  }, [
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    loadingSchool,
    loadingLevel,
    GetResponseData,
  ]);

  const handleConfigTabChange = (tab) => {
    if (tab === activeConfigTab) return;

    activeConfigTabRef.current = tab;
    setActiveConfigTab(tab);

    if (!hasSearched) return;

    const rows = tab === "siswa" ? getDataSiswa : getDataPembina;
    const kelasTabs = buildKelasTabsFromMatpels(
      rows,
      form2.ysb_grade_level_id
    );

    setGetData(rows);
    setHeaderKelas(kelasTabs);

    setActiveKelasId((prevActiveKelasId) => {
      const stillExists = kelasTabs.some(
        (item) =>
          String(item?.ysb_kelas_id) === String(prevActiveKelasId)
      );

      if (prevActiveKelasId && stillExists) {
        return prevActiveKelasId;
      }

      return kelasTabs?.[0]?.ysb_kelas_id || "";
    });
  };

  // =========================
  // HANDLER perubahan filter
  // =========================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (name === "ysb_semester_id") {
      const selectedYear = getDataAcademicYear.find(
        (item) => String(item?.id) === String(value)
      );

      setNamaTA(selectedYear?.name_year || selectedYear?.name || "");

      const semestersByYear = getSemesterByAcademicYear(value);
      setGetDataSemesterMap(semestersByYear);

    }

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const handleCari = async () => {
    if (
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id
    ) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Cabang, Sekolah, dan Tingkatan sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setActiveKelasId("");
    setGetData([]);
    setGetDataPembina([]);
    setGetDataSiswa([]);
    setHeaderKelas([]);
    setHasSearched(false);
    setNilaiEkskulId("");
    setNilaiSemesterId("");
    setNilaiStudentSearch("");

    await GetResponseData();
  };

  const filteredData = useMemo(() => {
    if (!Array.isArray(getData)) return [];

    let rows = getData;

    const keywordValue = searchKeyword.trim().toLowerCase();

    if (keywordValue) {
      rows = rows.filter((item) =>
        String(item?.name_matpel || "").toLowerCase().includes(keywordValue)
      );
    }

    return rows;
  }, [getData, searchKeyword]);

  // =========================
  // DATA TAB NILAI
  // Filter ekstrakurikuler mengambil sumber dari endpoint nilai terbaru.
  // =========================
  const nilaiEkskulOptions = useMemo(() => {
    const unique = new Map();

    (nilaiScoreRows || []).forEach((row) => {
      const ekskulId = row?.ysb_matpel_id || row?.id || "";
      if (!ekskulId) return;

      if (!unique.has(String(ekskulId))) {
        unique.set(String(ekskulId), {
          ...row,
          id: ekskulId,
          ysb_matpel_id: ekskulId,
          nama_matpel:
            row?.nama_matpel || row?.name_matpel || row?.name || "Ekstrakurikuler",
          name_matpel:
            row?.name_matpel || row?.nama_matpel || row?.name || "Ekstrakurikuler",
          ysb_grade_level_id:
            row?.ysb_grade_level_id || form2.ysb_grade_level_id || "",
          selected_grade_level_ids: [form2.ysb_grade_level_id].filter(Boolean),
        });
      }
    });

    return Array.from(unique.values()).sort((a, b) =>
      String(a?.name_matpel || "").localeCompare(
        String(b?.name_matpel || ""),
        "id",
        { sensitivity: "base", numeric: true }
      )
    );
  }, [nilaiScoreRows, form2.ysb_grade_level_id]);

  const selectedNilaiEkskul = useMemo(
    () =>
      nilaiEkskulOptions.find(
        (item) => String(item?.ysb_matpel_id || item?.id || "") === String(nilaiEkskulId)
      ) || nilaiEkskulOptions[0] || null,
    [nilaiEkskulOptions, nilaiEkskulId]
  );

  const nilaiSemesterOptions = useMemo(() => {
    return [...(getDataSemesterMap || [])].sort(
      (a, b) => Number(a?.semester || 0) - Number(b?.semester || 0)
    );
  }, [getDataSemesterMap]);

  useEffect(() => {
    if (nilaiEkskulOptions.length === 0) {
      setNilaiEkskulId("");
      return;
    }

    const stillExists = nilaiEkskulOptions.some(
      (item) =>
        String(item?.ysb_matpel_id || item?.id || "") === String(nilaiEkskulId)
    );

    if (!stillExists) {
      setNilaiEkskulId(
        nilaiEkskulOptions[0]?.ysb_matpel_id || nilaiEkskulOptions[0]?.id || ""
      );
    }
  }, [nilaiEkskulOptions, nilaiEkskulId]);

  useEffect(() => {
    if (nilaiSemesterOptions.length === 0) {
      setNilaiSemesterId("");
      return;
    }

    const stillExists = nilaiSemesterOptions.some(
      (item) =>
        String(item?.id || item?.ysb_semester_id || "") ===
        String(nilaiSemesterId)
    );

    if (!stillExists) {
      const activeSemesterItem =
        nilaiSemesterOptions.find(
          (item) =>
            item?.status === 1 ||
            item?.status === "1" ||
            item?.is_active === 1 ||
            item?.is_active === true
        ) || nilaiSemesterOptions[0];

      setNilaiSemesterId(
        activeSemesterItem?.id || activeSemesterItem?.ysb_semester_id || ""
      );
    }
  }, [nilaiSemesterOptions, nilaiSemesterId]);

  /*
   * =========================================================
   * CACHE NILAI PER EKSTRAKURIKULER, BUKAN PER SEMESTER
   * =========================================================
   *
   * Endpoint input-scores mengembalikan data kelas beserta daftar
   * semesters di dalam response. Karena itu kita cukup GET SATU KALI
   * untuk satu ekstrakurikuler pada filter utama yang aktif.
   *
   * Semester 1 / Semester 2 hanya memilih data dari response yang sudah
   * ada di cache. Jadi saat user klik semester, TIDAK ada GET dan loading
   * lagi.
   */
  const nilaiScoreCacheKey = useMemo(() => {
    const ekskulId =
      selectedNilaiEkskul?.ysb_matpel_id ||
      selectedNilaiEkskul?.id ||
      "";

    if (
      !ekskulId ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id
    ) {
      return "";
    }

    return [
      ekskulId,
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
    ].join("|");
  }, [
    selectedNilaiEkskul,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
  ]);

  const prefetchedNilaiDetail = useMemo(() => {
    if (!nilaiScoreCacheKey) return undefined;
    return nilaiScoreCache[nilaiScoreCacheKey];
  }, [nilaiScoreCache, nilaiScoreCacheKey]);

  const isNilaiPrefetching =
    Boolean(nilaiScoreCacheKey) &&
    !Object.prototype.hasOwnProperty.call(
      nilaiScoreCache,
      nilaiScoreCacheKey
    );

  const getNilaiToken = useCallback(() => token || "", [token]);
  const getNilaiBranchId = useCallback(
    () => form2.ysb_branch_id || "",
    [form2.ysb_branch_id]
  );
  const getNilaiSchoolId = useCallback(
    () => form2.ysb_school_id || "",
    [form2.ysb_school_id]
  );

  const handleNilaiSemesterChange = useCallback((semesterItem) => {
    setNilaiSemesterId(
      semesterItem?.id || semesterItem?.ysb_semester_id || ""
    );
  }, []);


  const deleteById = (row) => {
  const matpelId = row?.ysb_matpel_id || row?.id || "";

  if (
    !form2.ysb_semester_id ||
    !form2.ysb_branch_id ||
    !form2.ysb_school_id ||
    !form2.ysb_grade_level_id ||
    !matpelId
  ) {
    ToastError.fire({
      icon: "error",
      title: "Data belum lengkap untuk menghapus ekstrakurikuler",
    });
    return;
  }

  Swal.fire({
    title: "Hapus Ekstrakurikuler?",
    text: `Yakin ingin menghapus ${row?.name_matpel || "ekstrakurikuler"} dari konfigurasi?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ya, Hapus",
    cancelButtonText: "Batal",
    confirmButtonColor: "#ef4444",
    cancelButtonColor: "#6b7280",
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(),

    preConfirm: async () => {
      try {
        const response = await APISD.delete(`/api/ekstrakurikuler-configs/destroy`, {
          ...fetchParams,
          data: {
            ysb_academic_year_id: form2.ysb_semester_id,
            ysb_branch_id: form2.ysb_branch_id,
            ysb_school_id: form2.ysb_school_id,
            ysb_grade_level_id: form2.ysb_grade_level_id,
            ysb_matpel_id: matpelId,
            user_id: output_id_user,
          },
        });

        if (response?.data?.error) {
          throw new Error(response?.data?.message || "Gagal menghapus data");
        }

        return response;
      } catch (error) {
        Swal.showValidationMessage(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Gagal menghapus data"
        );
      }
    },
  }).then((result) => {
    if (result.isConfirmed) {
      ToastSuccess.fire({
        icon: "success",
        title: "Ekstrakurikuler berhasil dihapus",
      });

      GetResponseData();
    }
  });
};


  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.slice(1)
    );
  };

  const toTitleCaseGelar = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";

    return s
      .split(" ")
      .map((word) => {
        // khusus gelar yang ada titik, contoh: s.si. -> S.Si.
        if (word.includes(".")) {
          return word
            .split(".")
            .map((part) => {
              if (!part) return "";
              return part.charAt(0).toUpperCase() + part.slice(1);
            })
            .join(".");
        }

        // normal title case, contoh: helmy -> Helmy
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const renderAvailableMark = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "38px",
        }}
      >
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            backgroundColor: "#22c55e",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "18px",
            fontWeight: "bold",
            lineHeight: 1,
          }}
        >
          ✓
        </div>
      </div>
    );
  };

  const renderUnavailableMark = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "38px",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "24px",
            height: "24px",
          }}
        >
          <span
            style={{
              position: "absolute",
              top: "10px",
              left: "0",
              width: "24px",
              height: "3px",
              backgroundColor: "#ef4444",
              borderRadius: "999px",
              transform: "rotate(45deg)",
            }}
          />
          <span
            style={{
              position: "absolute",
              top: "10px",
              left: "0",
              width: "24px",
              height: "3px",
              backgroundColor: "#ef4444",
              borderRadius: "999px",
              transform: "rotate(-45deg)",
            }}
          />
        </div>
      </div>
    );
  };

  const getGuruKey = (row, kelasId, semester) => {
    const matpelId = row?.ysb_matpel_id || row?.id || "";
    return `${matpelId}__${kelasId}__semester_${semester}`;
  };


  const openTambahGuruModal = (row, kelasId = "", semester = "") => {
    setSelectedMatpelRow({
      ...row,
      targetKelasId: kelasId,
      targetSemester: semester,
    });
    setModalTambahGuru(true);
  };

  const closeTambahGuruModal = () => {
    setModalTambahGuru(false);
    setSelectedMatpelRow(null);
  };

  // const openUpdateGuruModal = (row) => {
  //   setSelectedUpdateGuruRow(row);
  //   setModalUpdateGuru(true);
  // };

  const openUpdateGuruModal = (row, kelasId = "", semester = "") => {
    setSelectedUpdateGuruRow({
      ...row,
      targetKelasId: kelasId,
      targetSemester: semester,
    });

    setModalUpdateGuru(true);
  };

  const closeUpdateGuruModal = () => {
    setModalUpdateGuru(false);
    setSelectedUpdateGuruRow(null);
  };

  const getStudentKey = (row, kelasId, semester) => {
    const matpelId = row?.ysb_matpel_id || row?.id || "";
    return `${form2.ysb_school_id}__${form2.ysb_semester_id}__${matpelId}__${kelasId}__semester_${semester}`;
  };

  const getStudentsFromRowResponse = (row, kelasId, semester) => {
    const targetSemester = getSemesterFromRowResponse(row, kelasId, semester);

    if (String(targetSemester?.state_form) !== "1") return [];

    const students =
      targetSemester?.students ||
      targetSemester?.student ||
      targetSemester?.data_students ||
      [];

    return (Array.isArray(students) ? students : []).filter(
      (student) => String(student?.state_form ?? "1") === "1"
    );
  };

  const getStudentId = (student) =>
    String(
      student?.ysb_student_id ||
        student?.student_id ||
        student?.id ||
        student?.nisn ||
        ""
    );

  // const getStudentName = (student) =>
  //   student?.nama_siswa ||
  //   student?.student_name ||
  //   student?.name ||
  //   student?.full_name ||
  //   "-";

  const getStudentName = (student) =>
    student?.nama_lengkap ||
    student?.nama_siswa ||
    student?.student_name ||
    student?.full_name ||
    student?.name ||
    "-";

  const getStudentNisn = (student) =>
    student?.nisn ||
    student?.NISN ||
    student?.nis ||
    "-";

  const getStudentInitial = (student) => {
    const name = String(getStudentName(student) || "").trim();

    if (!name || name === "-") {
      return "S";
    }

    return name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  };

const getStudentTotal = (row, kelasId, semester) => {
  const studentKey = getStudentKey(row, kelasId, semester);
  const studentsFromState = studentMap[studentKey];

  // Kalau baru saja tambah/update siswa dari modal,
  // prioritaskan data terbaru dari state.
  if (Array.isArray(studentsFromState)) {
    return studentsFromState.filter(
      (student) => String(student?.state_form ?? "1") === "1"
    ).length;
  }

  const targetSemester = getSemesterFromRowResponse(
    row,
    kelasId,
    semester
  );

  // Ambil langsung dari response student-config
  const totalFromApi = Number(targetSemester?.jumlah_siswa);

  if (Number.isFinite(totalFromApi) && totalFromApi >= 0) {
    return totalFromApi;
  }

  // fallback
  return getStudentsFromRowResponse(row, kelasId, semester).length;
};

const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

// const openStudentListModal = (
//   row,
//   kelasId = "",
//   semester = ""
// ) => {
//   const students = [
//     ...getResolvedStudents(row, kelasId, semester),
//   ].sort((a, b) =>
//     String(getStudentName(a)).localeCompare(
//       String(getStudentName(b)),
//       "id",
//       {
//         numeric: true,
//         sensitivity: "base",
//       }
//     )
//   );

//   const totalStudent = getStudentTotal(
//     row,
//     kelasId,
//     semester
//   );

//   const kelas = headerKelas.find(
//     (item) =>
//       String(item?.ysb_kelas_id) === String(kelasId)
//   );

//   const kelasTitleRaw =
//     kelas?.title ||
//     [kelas?.name_level, kelas?.name_kelas]
//       .filter(Boolean)
//       .join(" ") ||
//     "-";

//   const kelasTitle = String(kelasTitleRaw || "")
//     .toLowerCase()
//     .startsWith("kelas")
//     ? kelasTitleRaw
//     : `Kelas ${toTitleCase(kelasTitleRaw)}`;

//   const rowsHtml =
//     students.length > 0
//       ? students
//           .map(
//             (student, index) => `
//               <tr>
//                 <td
//                   style="
//                     width:52px;
//                     text-align:center;
//                     padding:10px 8px;
//                     border-bottom:1px solid #e5e7eb;
//                     color:#6b7280;
//                     font-size:13px;
//                   "
//                 >
//                   ${index + 1}
//                 </td>

//                 <td
//                   style="
//                     width:150px;
//                     padding:10px 12px;
//                     border-bottom:1px solid #e5e7eb;
//                     color:#374151;
//                     font-size:13px;
//                     white-space:nowrap;
//                   "
//                 >
//                   ${escapeHtml(getStudentNisn(student))}
//                 </td>

//                 <td
//                   style="
//                     padding:10px 12px;
//                     border-bottom:1px solid #e5e7eb;
//                     color:#111827;
//                     font-size:13px;
//                     font-weight:600;
//                     text-align:left;
//                   "
//                 >
//                   ${escapeHtml(
//                     toTitleCase(getStudentName(student))
//                   )}
//                 </td>
//               </tr>
//             `
//           )
//           .join("")
//       : `
//           <tr>
//             <td
//               colspan="3"
//               style="
//                 padding:28px 12px;
//                 text-align:center;
//                 color:#6b7280;
//                 font-size:13px;
//               "
//             >
//               Belum ada siswa yang terdaftar.
//             </td>
//           </tr>
//         `;

//   Swal.fire({
//     title: "Daftar Siswa Terdaftar",

//     width: 720,

//     showCloseButton: true,

//     confirmButtonText: "Tutup",

//     confirmButtonColor: "#3f5bea",

//     html: `
//       <div style="text-align:left;">

//         <div
//           style="
//             background:#f8fafc;
//             border:1px solid #e5e7eb;
//             border-radius:10px;
//             padding:12px 14px;
//             margin-bottom:14px;
//             font-size:13px;
//             color:#374151;
//           "
//         >
//           <div
//             style="
//               font-weight:700;
//               color:#111827;
//               margin-bottom:4px;
//             "
//           >
//             ${escapeHtml(
//               row?.name_matpel || "Ekstrakurikuler"
//             )}
//           </div>

//           <div>
//             ${escapeHtml(kelasTitle)}
//             &nbsp;•&nbsp;
//             Semester ${escapeHtml(semester)}
//             &nbsp;•&nbsp;
//             <b>${totalStudent} siswa</b>
//           </div>
//         </div>

//         <div
//           style="
//             max-height:380px;
//             overflow:auto;
//             border:1px solid #e5e7eb;
//             border-radius:10px;
//           "
//         >
//           <table
//             style="
//               width:100%;
//               border-collapse:collapse;
//               background:#fff;
//             "
//           >
//             <thead>
//               <tr
//                 style="
//                   position:sticky;
//                   top:0;
//                   z-index:1;
//                   background:#f3f6ff;
//                 "
//               >
//                 <th
//                   style="
//                     width:52px;
//                     text-align:center;
//                     padding:10px 8px;
//                     color:#374151;
//                     font-size:12px;
//                     border-bottom:1px solid #dbe3f4;
//                   "
//                 >
//                   No
//                 </th>

//                 <th
//                   style="
//                     width:150px;
//                     text-align:left;
//                     padding:10px 12px;
//                     color:#374151;
//                     font-size:12px;
//                     border-bottom:1px solid #dbe3f4;
//                   "
//                 >
//                   NISN
//                 </th>

//                 <th
//                   style="
//                     text-align:left;
//                     padding:10px 12px;
//                     color:#374151;
//                     font-size:12px;
//                     border-bottom:1px solid #dbe3f4;
//                   "
//                 >
//                   Nama Siswa
//                 </th>
//               </tr>
//             </thead>

//             <tbody>
//               ${rowsHtml}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     `,
//   });
// };


  const openStudentListModal = (
    row,
    kelasId = "",
    semester = ""
  ) => {
    const students = [
      ...getResolvedStudents(row, kelasId, semester),
    ].sort((a, b) =>
      String(getStudentName(a)).localeCompare(
        String(getStudentName(b)),
        "id",
        {
          numeric: true,
          sensitivity: "base",
        }
      )
    );

    const kelas = headerKelas.find(
      (item) =>
        String(item?.ysb_kelas_id) === String(kelasId)
    );

    const kelasRawTitle =
      kelas?.title ||
      [kelas?.name_level, kelas?.name_kelas]
        .filter(Boolean)
        .join(" ") ||
      "-";

    const kelasTitle = String(kelasRawTitle || "")
      .toLowerCase()
      .startsWith("kelas")
      ? kelasRawTitle
      : `Kelas ${toTitleCase(kelasRawTitle)}`;

    setSelectedStudentList({
      row,
      kelasId,
      semester,
      kelasTitle,
      students,
      total: getStudentTotal(row, kelasId, semester),
    });

    setModalDaftarSiswa(true);
  };

  const closeStudentListModal = () => {
    setModalDaftarSiswa(false);
    setSelectedStudentList(null);
  };

  const getStudentInitials = (student) => {
    const name = getStudentName(student)
      .replace(/[^a-zA-ZÀ-ÿ\s]/g, " ")
      .trim();

    if (!name) return "S";

    return name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  };

  const getResolvedStudents = (row, kelasId, semester) => {
    const studentKey = getStudentKey(row, kelasId, semester);
    const fromState = studentMap[studentKey];

    if (Array.isArray(fromState)) return fromState;

    return getStudentsFromRowResponse(row, kelasId, semester);
  };

  const openTambahSiswaModal = (
    row,
    kelasId = "",
    semester = "",
    studentMode = "create"
  ) => {
    // Ambil ID + nama semester langsung dari response student-config.
    // Jadi ketika pindah Semester 1 / Semester 2, modal tidak lagi
    // bergantung ke ID semester dari endpoint master /api/semesters.
    const semesterData = getSemesterFromRowResponse(row, kelasId, semester);
    const semesterNumber =
      semesterData?.name_semester ??
      semesterData?.semester ??
      semester;
    const semesterId =
      semesterData?.ysb_semester_id ||
      semesterData?.id ||
      "";

    setSelectedStudentRow({
      ...row,
      targetKelasId: kelasId,
      targetSemester: Number(semesterNumber) || semesterNumber,
      targetSemesterId: semesterId,
      targetSemesterName: semesterNumber,
      studentMode,
    });
    setModalTambahSiswa(true);
  };

  const closeTambahSiswaModal = () => {
    setModalTambahSiswa(false);
    setSelectedStudentRow(null);
  };


  const getVisibleSemestersByKelas = (kelasId) => {
  return [1, 2].filter((semester) => {
    return getData.some((row) => {
      const isAvailableInKelas = isMatpelInKelas(
        row,
        form2.ysb_grade_level_id,
        kelasId
      );

      return (
        isAvailableInKelas &&
        isSemesterFormActive(row, kelasId, semester)
      );
    });
  });
};

const getVisibleHeaderKelas = () => {
  return headerKelas.filter((kelas) => {
    const kelasId = kelas?.ysb_kelas_id || "";
    const visibleSemesters = getVisibleSemestersByKelas(kelasId);

    return visibleSemesters.length > 0;
  });
};

  const getSemesterFromRowResponse = (row, kelasId, semester) => {
  const targetLevel = (row?.grade_levels || []).find(
    (level) =>
      String(level?.ysb_grade_level_id) === String(form2.ysb_grade_level_id)
  );

  const targetKelas = (targetLevel?.kelas || []).find(
    (kelas) => String(kelas?.ysb_kelas_id) === String(kelasId)
  );

  const semesterOptions = getSemesterOptions();

  const selectedSemester = semesterOptions.find((sem) => {
    const rawSemester =
      sem?.raw?.semester ||
      sem?.raw?.name_semester ||
      sem?.label?.replace("Semester ", "");

    return String(rawSemester) === String(semester);
  });

  const targetSemester = (targetKelas?.semesters || []).find((item) => {
    const semesterNumber =
      item?.semester ||
      item?.name_semester ||
      item?.label ||
      "";

    const semesterId =
      item?.ysb_semester_id ||
      item?.id ||
      "";

    return (
      String(semesterNumber) === String(semester) ||
      String(semesterId) === String(selectedSemester?.id)
    );
  });

  return targetSemester || null;
};

const isSemesterFormActive = (row, kelasId, semester) => {
  const targetSemester = getSemesterFromRowResponse(row, kelasId, semester);

  // semester.state_form = 1 => cell boleh tampil
  // semester.state_form = 0 / tidak ada => cell kosong
  return String(targetSemester?.state_form) === "1";
};

//   const getTeachersFromRowResponse = (row, kelasId, semester) => {
//   const targetLevel = (row?.grade_levels || []).find(
//     (level) =>
//       String(level?.ysb_grade_level_id) === String(form2.ysb_grade_level_id)
//   );

//   const targetKelas = (targetLevel?.kelas || []).find(
//     (kelas) => String(kelas?.ysb_kelas_id) === String(kelasId)
//   );

//   const targetSemester = (targetKelas?.semesters || []).find((item) => {
//     const semesterNumber =
//       item?.semester ||
//       item?.name_semester ||
//       item?.label ||
//       "";

//     const semesterId =
//       item?.ysb_semester_id ||
//       item?.id ||
//       "";

//     const semesterOptions = getSemesterOptions();

//     const selectedSemester = semesterOptions.find((sem) => {
//       const rawSemester =
//         sem?.raw?.semester ||
//         sem?.raw?.name_semester ||
//         sem?.label?.replace("Semester ", "");

//       return String(rawSemester) === String(semester);
//     });

//     return (
//       String(semesterNumber) === String(semester) ||
//       String(semesterId) === String(selectedSemester?.id)
//     );
//   });

//   return (targetSemester?.teachers || []).filter(
//     (teacher) => String(teacher?.state_form) === "1"
//   );
// };


const getTeachersFromRowResponse = (row, kelasId, semester) => {
  const targetSemester = getSemesterFromRowResponse(row, kelasId, semester);

  // Kalau semester.state_form = 0, guru tidak perlu dicek.
  // Cell nanti dibuat kosong.
  if (String(targetSemester?.state_form) !== "1") {
    return [];
  }

  // teacher.state_form = 1 saja yang namanya tampil
  return (targetSemester?.teachers || []).filter(
    (teacher) => String(teacher?.state_form) === "1"
  );
};


const renderGuruOrAvailableMark = (
  row,
  kelasId,
  semester,
  isAvailableInKelas
) => {
  if (!isAvailableInKelas) return renderUnavailableMark();

  // semester.state_form = 0 => cell kosong
  const semesterActive = isSemesterFormActive(row, kelasId, semester);
  if (!semesterActive) return null;

  const guruKey = getGuruKey(row, kelasId, semester);

  // prioritas 1: dari state setelah user baru simpan
  const gurusFromState = guruMap[guruKey];

  // prioritas 2: dari response API saat halaman reload
  const gurusFromResponse = getTeachersFromRowResponse(row, kelasId, semester);

  const gurusFromStateFiltered = Array.isArray(gurusFromState)
    ? gurusFromState.filter(
        (teacher) => String(teacher?.state_form ?? "1") === "1"
      )
    : [];

  const gurus =
    gurusFromStateFiltered.length > 0
      ? gurusFromStateFiltered
      : gurusFromResponse;

  if (Array.isArray(gurus) && gurus.length > 0) {
    return (
      <div
        style={{
          fontSize: "13px",
          fontWeight: 600,
          color: "#374151",
          lineHeight: "18px",
          padding: "6px 4px",
          textAlign: "center",
        }}
      >
        {gurus.map((guru, index) => {
          const guruName =
            guru?.name ||
            guru?.full_name ||
            guru?.teacher_name ||
            guru?.nama_lengkap ||
            "-";

          return (
            <div key={guru?.id || guru?.assignment_id || index}>
            - {toTitleCaseGelar(guruName)}
            </div>
          );
        })}

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            openUpdateGuruModal(row, kelasId, semester);
          }}
          style={{
            marginTop: "8px",
            border: "none",
            backgroundColor: "#facc15",
            color: "#1f2937",
            borderRadius: "8px",
            padding: "5px 10px",
            fontSize: "12px",
            fontWeight: 700,
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
            boxShadow: "0 4px 10px rgba(250, 204, 21, 0.25)",
          }}
        >
          <FontAwesomeIcon icon={faPenToSquare} />
          Update
        </button>
      </div>
    );
  }

  // semester.state_form = 1, tapi teacher.state_form = 0 semua
  // maka kelas tetap tampil, hanya nama guru tidak tampil
  return renderAvailableMark();
};


  const getResolvedTeachers = (row, kelasId, semester) => {
    const guruKey = getGuruKey(row, kelasId, semester);
    const gurusFromState = guruMap[guruKey];
    const gurusFromResponse = getTeachersFromRowResponse(
      row,
      kelasId,
      semester
    );

    const source =
      Array.isArray(gurusFromState) && gurusFromState.length > 0
        ? gurusFromState
        : gurusFromResponse;

    const uniqueTeachers = new Map();

    (source || [])
      .filter((teacher) => String(teacher?.state_form ?? "1") === "1")
      .forEach((teacher, index) => {
        const teacherId =
          teacher?.id ||
          teacher?.user_id ||
          teacher?.teacher_id ||
          teacher?.ysb_teacher_id ||
          teacher?.assignment_id ||
          `${getTeacherName(teacher)}-${index}`;

        uniqueTeachers.set(String(teacherId), teacher);
      });

    return Array.from(uniqueTeachers.values());
  };

  const getTeacherName = (teacher) => {
    return (
      teacher?.name ||
      teacher?.full_name ||
      teacher?.teacher_name ||
      teacher?.nama_lengkap ||
      "-"
    );
  };

  const getTeacherInitials = (teacher) => {
    const name = getTeacherName(teacher)
      .replace(/[^a-zA-ZÀ-ÿ\s]/g, " ")
      .trim();

    if (!name) return "G";

    return name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
  };

  const getClassMapelCount = (kelasId) => {
    const semesters = getVisibleSemestersByKelas(kelasId);
    const mapelIds = new Set();

    getData.forEach((row) => {
      const isInClass = isMatpelInKelas(
        row,
        form2.ysb_grade_level_id,
        kelasId
      );

      if (!isInClass) return;

      const activeInAnySemester = semesters.some((semester) =>
        isSemesterFormActive(row, kelasId, semester)
      );

      if (!activeInAnySemester) return;

      mapelIds.add(String(row?.ysb_matpel_id || row?.id || row?.name_matpel));
    });

    return mapelIds.size;
  };

  const handleSelectClass = (kelasId) => {
    setActiveKelasId(kelasId);

    const availableSemesters = getVisibleSemestersByKelas(kelasId);

    if (!availableSemesters.includes(Number(activeSemester))) {
      setActiveSemester(availableSemesters?.[0] || 1);
    }
  };

  const getSemesterOptions = () => {
    const semesters = Array.isArray(getDataSemesterMap)
      ? getDataSemesterMap
      : [];

    const mappedSemesters = semesters.map((item) => ({
      id: item?.id,
      label: item?.semester
        ? `Semester ${item.semester}`
        : item?.name_semester || item?.name || "Semester",
      raw: item,
    }));

    if (mappedSemesters.length > 0) {
      return mappedSemesters;
    }

    return [
      { id: "", label: "Semester 1", raw: null },
      { id: "", label: "Semester 2", raw: null },
    ];
  };

  // Khusus tab SISWA: sumber semester harus dari response
  // /api/ekstrakurikuler-students/student-config karena di sana
  // sudah tersedia pasangan ysb_semester_id + name_semester yang
  // sesuai dengan konfigurasi siswa per kelas.
  const getStudentSemesterTabsByKelas = (kelasId) => {
    const unique = new Map();

    (getDataSiswa || []).forEach((row) => {
      const targetLevel = (row?.grade_levels || []).find(
        (level) =>
          String(level?.ysb_grade_level_id) ===
          String(form2.ysb_grade_level_id)
      );

      const targetKelas = (targetLevel?.kelas || []).find(
        (kelas) => String(kelas?.ysb_kelas_id) === String(kelasId)
      );

      (targetKelas?.semesters || []).forEach((semesterItem) => {
        if (String(semesterItem?.state_form) !== "1") return;

        const semesterId =
          semesterItem?.ysb_semester_id ||
          semesterItem?.id ||
          "";
        const semesterName =
          semesterItem?.name_semester ??
          semesterItem?.semester ??
          semesterItem?.label ??
          "";
        const semesterNumber = Number(semesterName);

        if (!semesterId || !semesterName || !Number.isFinite(semesterNumber) || semesterNumber <= 0) return;

        const key = String(semesterId);
        if (!unique.has(key)) {
          unique.set(key, {
            id: semesterId,
            number: semesterNumber,
            label: `Semester ${semesterNumber}`,
            raw: semesterItem,
          });
        }
      });
    });

    return Array.from(unique.values()).sort(
      (a, b) => Number(a.number) - Number(b.number)
    );
  };

  const visibleClassCards = getVisibleHeaderKelas();
  const resolvedActiveKelasId = visibleClassCards.some(
    (kelas) => String(kelas?.ysb_kelas_id) === String(activeKelasId)
  )
    ? activeKelasId
    : visibleClassCards?.[0]?.ysb_kelas_id || "";
  const activeClass = visibleClassCards.find(
    (kelas) =>
      String(kelas?.ysb_kelas_id) === String(resolvedActiveKelasId)
  );
  const activeClassRawTitle =
    activeClass?.title || activeClass?.ysb_kelas_id || "";
  const activeClassTitle = String(activeClassRawTitle || "")
    .toLowerCase()
    .startsWith("kelas")
    ? activeClassRawTitle
    : activeClassRawTitle
    ? `Kelas ${toTitleCase(activeClassRawTitle)}`
    : "Pilih Kelas";
  const activeSemesterOptions = resolvedActiveKelasId
    ? getVisibleSemestersByKelas(resolvedActiveKelasId)
    : [];

  // Untuk tab siswa, label + ID semester diambil langsung dari student-config.
  const activeStudentSemesterTabs = resolvedActiveKelasId
    ? getStudentSemesterTabsByKelas(resolvedActiveKelasId)
    : [];

  const resolvedActiveSemester = activeSemesterOptions.includes(
    Number(activeSemester)
  )
    ? Number(activeSemester)
    : activeSemesterOptions?.[0] || 1;

  const getRowsByContext = (rows, kelasId, semester) => {
    if (!kelasId) return [];

    return (rows || []).filter(
      (row) =>
        isMatpelInKelas(row, form2.ysb_grade_level_id, kelasId) &&
        isSemesterFormActive(row, kelasId, semester)
    );
  };

  const filteredStudentData = useMemo(() => {
    if (!Array.isArray(getData)) return [];

    const keywordValue = studentSearchKeyword.trim().toLowerCase();
    if (!keywordValue) return getData;

    return getData.filter((item) =>
      String(item?.name_matpel || "").toLowerCase().includes(keywordValue)
    );
  }, [getData, studentSearchKeyword]);

  const activeContextRows = getRowsByContext(
    filteredData,
    resolvedActiveKelasId,
    resolvedActiveSemester
  );

  const activeContextRowsWithoutSearch = getRowsByContext(
    getData,
    resolvedActiveKelasId,
    resolvedActiveSemester
  );

  const activeStudentContextRows = getRowsByContext(
    filteredStudentData,
    resolvedActiveKelasId,
    resolvedActiveSemester
  );

  const activeTeacherCount = new Set(
    activeContextRowsWithoutSearch.flatMap((row) =>
      getResolvedTeachers(row, resolvedActiveKelasId, resolvedActiveSemester).map(
        (teacher, index) =>
          String(
            teacher?.id ||
              teacher?.user_id ||
              teacher?.teacher_id ||
              teacher?.ysb_teacher_id ||
              teacher?.assignment_id ||
              `${getTeacherName(teacher)}-${index}`
          )
      )
    )
  ).size;


  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body">
        <ModalAdd
          GetResponseData={GetResponseData}
          existingConfigMatpels={getData}
          academicYearId={form2.ysb_semester_id}
          academicYearName={namaTA}
          branchId={form2.ysb_branch_id}
          branchName={
            getDataBranch.find(
              (item) =>
                String(item?.branch_code) === String(form2.ysb_branch_id)
            )?.branch_name || form2.ysb_branch_id
          }
          schoolId={form2.ysb_school_id}
          schoolName={
            getDataSchool.find(
              (item) =>
                String(item?.school_code) === String(form2.ysb_school_id)
            )?.school_name || form2.ysb_school_id
          }
          gradeLevelId={form2.ysb_grade_level_id}
          gradeLevelName={
            getDataLevel.find(
              (item) => String(item?.id) === String(form2.ysb_grade_level_id)
            )?.name_level || ""
          }
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />


        <ModalConfigTeacher
          show={modalTambahGuru}
          onHide={closeTambahGuruModal}
          row={selectedMatpelRow}
          headerKelas={headerKelas}
          gradeLevelId={form2.ysb_grade_level_id}
          teachers={teachers}
          loadingTeachers={loadingTeachers}
          isTabletOrMobile={isTabletOrMobile}
          form2={form2}
          semesterOptions={getSemesterOptions()}
          fetchParams={fetchParams}
          outputIdUser={output_id_user}
          setGuruMap={setGuruMap}
          getGuruKey={getGuruKey}
          GetResponseData={GetResponseData}
        />

        <ModalUpdateConfigTeacher
          show={modalUpdateGuru}
          onHide={closeUpdateGuruModal}
          row={selectedUpdateGuruRow}
          headerKelas={headerKelas}
          gradeLevelId={form2.ysb_grade_level_id}
          teachers={teachers}
          loadingTeachers={loadingTeachers}
          isTabletOrMobile={isTabletOrMobile}
          form2={form2}
          semesterOptions={getSemesterOptions()}
          fetchParams={fetchParams}
          outputIdUser={output_id_user}
          setGuruMap={setGuruMap}
          getGuruKey={getGuruKey}
          GetResponseData={GetResponseData}
        />

        <ModalConfigStudent
          show={modalTambahSiswa}
          onHide={closeTambahSiswaModal}
          row={selectedStudentRow}
          gradeLevelId={form2.ysb_grade_level_id}
          form2={form2}
          semesterOptions={getSemesterOptions()}
          fetchParams={fetchParams}
          outputIdUser={output_id_user}
          studentMap={studentMap}
          setStudentMap={setStudentMap}
          getStudentKey={getStudentKey}
          GetResponseData={GetResponseData}
        />

        {/* =========================================
        MODAL DAFTAR SISWA TERDAFTAR
        ========================================= */}
        {modalDaftarSiswa && selectedStudentList && (
          <div
            className="cm-student-modal-overlay"
            onClick={closeStudentListModal}
          >
            <div
              className="cm-student-modal"
              onClick={(e) => e.stopPropagation()}
            >
              {/* HEADER */}
              <div className="cm-student-modal-header">
                <div className="cm-student-modal-heading">
                  {/* <span className="cm-student-modal-label">
                    Siswa Ekstrakurikuler
                  </span> */}
            

                  <h5 className="cm-student-modal-title">
                    {selectedStudentList?.row?.name_matpel || "-"}
                  </h5>
                </div>

                <button
                  type="button"
                  className="cm-student-modal-close"
                  onClick={closeStudentListModal}
                  aria-label="Tutup"
                >
                  ×
                </button>
              </div>

              {/* BODY */}
              <div className="cm-student-modal-body">
                {/* INFO */}
                <div className="cm-student-modal-info">
                  <div className="cm-student-modal-info-item">
                    <span>Kelas</span>
                    <strong>
                      {selectedStudentList?.kelasTitle || "-"}
                    </strong>
                  </div>

                  <div className="cm-student-modal-info-item">
                    <span>Semester</span>
                    <strong>
                      Semester {selectedStudentList?.semester || "-"}
                    </strong>
                  </div>

                  <div className="cm-student-modal-info-item">
                    <span>Total Siswa</span>
                    <strong>
                      {selectedStudentList?.total || 0} Siswa
                    </strong>
                  </div>
                </div>

                {/* TABLE */}
                <div className="cm-student-table-card">
                  <div className="cm-student-table-scroll">
                    <table className="cm-student-table">
                      <thead>
                        <tr>
                          <th className="cm-student-no">
                            No
                          </th>

                          <th className="cm-student-nisn">
                            NISN
                          </th>

                          <th>
                            Nama Siswa
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {!Array.isArray(
                          selectedStudentList?.students
                        ) ||
                        selectedStudentList.students.length === 0 ? (
                          <tr>
                            <td
                              colSpan={3}
                              className="cm-student-empty"
                            >
                              Belum ada siswa yang terdaftar
                            </td>
                          </tr>
                        ) : (
                          selectedStudentList.students.map(
                            (student, studentIndex) => {
                              const studentId =
                                student?.ysb_student_id ||
                                student?.student_id ||
                                student?.id ||
                                studentIndex;

                              const studentName =
                                getStudentName(student);

                              return (
                                <tr
                                  key={`student-list-${studentId}-${studentIndex}`}
                                >
                                  <td className="cm-student-no">
                                    <span className="module-number-badge">
                                      {studentIndex + 1}
                                    </span>
                                  </td>

                                  <td className="cm-student-nisn">
                                    <span className="cm-student-nisn-text">
                                      {getStudentNisn(student)}
                                    </span>
                                  </td>

                                  <td>
                                    <div className="cm-student-person">
                                      <span className="cm-student-avatar">
                                        {getStudentInitial(student)}
                                      </span>

                                      <span className="cm-student-person-name">
                                        {toTitleCase(studentName)}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* FOOTER */}
              <div className="cm-student-modal-footer">
                <button
                  type="button"
                  className="cm-student-modal-close-button"
                  onClick={closeStudentListModal}
                >
                  Tutup
                </button>
              </div>
            </div>
          </div>
        )}

        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          nameUpdate={nameUpdate}
          rowData={updateData}
          academicYearId={form2.ysb_semester_id}
          academicYearName={namaTA}
          branchId={form2.ysb_branch_id}
          branchName={
            getDataBranch.find(
              (item) =>
                String(item?.branch_code) === String(form2.ysb_branch_id)
            )?.branch_name || form2.ysb_branch_id
          }
          schoolId={form2.ysb_school_id}
          schoolName={
            getDataSchool.find(
              (item) =>
                String(item?.school_code) === String(form2.ysb_school_id)
            )?.school_name || form2.ysb_school_id
          }
          gradeLevelId={form2.ysb_grade_level_id}
          gradeLevelName={
            getDataLevel.find(
              (item) => String(item?.id) === String(form2.ysb_grade_level_id)
            )?.name_level || ""
          }
          show={modalUpdate}
          onHide={() => {
            setModalUpdate(false);
            setUpdateData(null);
          }}
        />

        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faBook} />
              </span>

              <h4 className="page-title-text">
                Konfigurasi Ekstrakurikuler, Pembina, Siswa & Nilai
              </h4>
            </div>

            <div className="ml-auto">
              {activeConfigTab === "pembina" && (
                <button
                  type="button"
                  onClick={() => setModalAdd(true)}
                  className="btn btn-create module-header-button"
                  disabled={
                    !form2.ysb_semester_id ||
                    !form2.ysb_branch_id ||
                    !form2.ysb_school_id ||
                    !form2.ysb_grade_level_id
                  }
                  title={
                    !form2.ysb_semester_id ||
                    !form2.ysb_branch_id ||
                    !form2.ysb_school_id ||
                    !form2.ysb_grade_level_id
                      ? "Lengkapi filter terlebih dahulu"
                      : "Tambah konfigurasi ekstrakurikuler"
                  }
                >
                  <FontAwesomeIcon icon={faPlus} />
                  <span>Tambah Ekskul Kelas</span>
                </button>
              )}
            </div>
          </div>

          <nav
            aria-label="breadcrumb"
            className="custom-breadcrumb-nav mt-4"
          >
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/ekskuls">Ekstrakurikuler</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li
                className="custom-breadcrumb-item active"
                aria-current="page"
              >
                Konfigurasi Ekstrakurikuler
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content">
          {/* <div className="config-main-tabs" role="tablist" aria-label="Konfigurasi ekstrakurikuler">
            <button
              type="button"
              className={`config-main-tab ${activeConfigTab === "pembina" ? "is-active" : ""}`}
              onClick={() => handleConfigTabChange("pembina")}
              role="tab"
              aria-selected={activeConfigTab === "pembina"}
            >
              <FontAwesomeIcon icon={faChalkboardUser} />
              <span>Pembina</span>
            </button>

            <button
              type="button"
              className={`config-main-tab ${activeConfigTab === "siswa" ? "is-active" : ""}`}
              onClick={() => handleConfigTabChange("siswa")}
              role="tab"
              aria-selected={activeConfigTab === "siswa"}
            >
              <FontAwesomeIcon icon={faUsers} />
              <span>Siswa</span>
            </button>
          </div> */}



          {/* FILTER */}
          <div className="config-matpel-filter-card">
            {loading ? (
              <div className="config-matpel-filter-grid">
                {[1, 2, 3, 4, 5].map((item) => (
                  <div
                    key={`filter-skeleton-${item}`}
                    className={`shimmer config-matpel-filter-skeleton ${
                      item === 5 ? "is-button" : ""
                    }`}
                  />
                ))}
              </div>
            ) : (
              <>
              <div className="config-matpel-filter-grid">
                <div className="config-matpel-filter-group">
                  <label htmlFor="filter-academic-year">Tahun Ajaran</label>
                  <select
                    id="filter-academic-year"
                    className="config-matpel-filter-select"
                    name="ysb_semester_id"
                    value={form2.ysb_semester_id}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      Pilih Tahun Ajaran
                    </option>

                    {getDataAcademicYear.map((item, index) => (
                      <option key={item?.id || index} value={item?.id}>
                        {item?.name_year || item?.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="config-matpel-filter-group">
                  <label htmlFor="filter-branch">Cabang</label>
                  <select
                    id="filter-branch"
                    className="config-matpel-filter-select"
                    name="ysb_branch_id"
                    value={form2.ysb_branch_id}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      Pilih Cabang
                    </option>
                    {getDataBranch.map((user, index) => (
                      <option key={index} value={user?.branch_code}>
                        {user?.branch_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="config-matpel-filter-group">
                  <label htmlFor="filter-school">Sekolah</label>
                  <select
                    id="filter-school"
                    className="config-matpel-filter-select"
                    name="ysb_school_id"
                    value={form2.ysb_school_id}
                    onChange={handleChange}
                    disabled={loadingSchool || !form2.ysb_branch_id}
                  >
                    <option value="" hidden>
                      {loadingSchool ? "Memuat..." : "Pilih Sekolah"}
                    </option>

                    {!loadingSchool &&
                      getDataSchool.map((user, index) => (
                        <option key={index} value={user?.school_code}>
                          {user?.school_name}
                        </option>
                      ))}
                  </select>
                </div>
                
                <div className="config-matpel-filter-group">
                  <label htmlFor="filter-grade-level">Tingkatan</label>
                    <select
                      id="filter-grade-level"
                      className="config-matpel-filter-select"
                      name="ysb_grade_level_id"
                      value={form2.ysb_grade_level_id}
                      onChange={handleChange}
                      disabled={loadingLevel || !form2.ysb_school_id}
                    >
                      <option value="" hidden>
                        {loadingLevel ? "Memuat..." : "Pilih Tingkatan"}
                      </option>

                      {!loadingLevel &&
                        getDataLevel.map((user, index) => (
                          <option key={index} value={user?.id}>
                            Tingkatan {user?.name_level}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="config-matpel-filter-action">
                    <button
                      type="button"
                      onClick={handleCari}
                      className="config-matpel-filter-button"
                      disabled={isFetching || loadingSchool || loadingLevel}
                    >
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                      <span>{isFetching ? "Mencari..." : "Cari"}</span>
                    </button>
                  </div>
                </div>
              </>
              
            )}
          </div>

          {hasSearched && !isFetching && (
            <div
              className="config-main-tabs"
              role="tablist"
              aria-label="Konfigurasi ekstrakurikuler"
            >
              <button
                type="button"
                className={`config-main-tab ${
                  activeConfigTab === "pembina" ? "is-active" : ""
                }`}
                onClick={() => handleConfigTabChange("pembina")}
                role="tab"
                aria-selected={activeConfigTab === "pembina"}
              >
                Pembina
              </button>

              <button
                type="button"
                className={`config-main-tab ${
                  activeConfigTab === "siswa" ? "is-active" : ""
                }`}
                onClick={() => handleConfigTabChange("siswa")}
                role="tab"
                aria-selected={activeConfigTab === "siswa"}
              >
                Siswa
              </button>

              <button
                type="button"
                className={`config-main-tab ${
                  activeConfigTab === "nilai" ? "is-active" : ""
                }`}
                onClick={() => handleConfigTabChange("nilai")}
                role="tab"
                aria-selected={activeConfigTab === "nilai"}
              >
                Nilai
              </button>
            </div>
          )}

          {isFetching && (
            <div className="config-data-preloader" role="status" aria-live="polite">
              <PulseLoader color={"#3f5bea"} size={10} />
              {/* <span>Memuat data konfigurasi ekstrakurikuler...</span> */}
            </div>
          )}

          {hasSearched && !isFetching && (
            <Col
              xl="12"
              sm="12"
              style={{ display: activeConfigTab === "nilai" ? undefined : "none" }}
              aria-hidden={activeConfigTab !== "nilai"}
            >
              <div className="config-matpel-workspace nilai-config-workspace mt-3">
                <div className="nilai-filter-card">
                  <div className="nilai-filter-group">
                    <label htmlFor="nilai-ekskul-filter">Ekstrakurikuler</label>
                    <select
                      id="nilai-ekskul-filter"
                      className="nilai-filter-select"
                      value={nilaiEkskulId}
                      onChange={(e) => {
                        setNilaiEkskulId(e.target.value);
                        setNilaiStudentSearch("");
                      }}
                    >
                      {nilaiEkskulOptions.length === 0 ? (
                        <option value="">Ekstrakurikuler tidak tersedia</option>
                      ) : (
                        nilaiEkskulOptions.map((item, index) => {
                          const ekskulId = item?.ysb_matpel_id || item?.id || "";
                          return (
                            <option key={`nilai-ekskul-${ekskulId || index}`} value={ekskulId}>
                              {item?.name_matpel || item?.nama_matpel || "Ekstrakurikuler"}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>

                  <div className="nilai-student-search">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    <input
                      type="text"
                      value={nilaiStudentSearch}
                      onChange={(e) => setNilaiStudentSearch(e.target.value)}
                      placeholder="Cari nama siswa / NISN..."
                      disabled={!selectedNilaiEkskul}
                    />
                  </div>
                </div>

                {selectedNilaiEkskul && nilaiSemesterId ? (
                  <NilaiEkskulTab
                    selectedMatpel={selectedNilaiEkskul}
                    selectedAcademicYearId={form2.ysb_semester_id}
                    selectedSemesterId={nilaiSemesterId}
                    semesterOptions={nilaiSemesterOptions}
                    onSemesterChange={handleNilaiSemesterChange}
                    studentSearchKeyword={nilaiStudentSearch}
                    getToken={getNilaiToken}
                    getBranchId={getNilaiBranchId}
                    getSchoolId={getNilaiSchoolId}
                    prefetchedDetailData={prefetchedNilaiDetail}
                    prefetchedLoading={isNilaiPrefetching}
                    embedded
                  />
                ) : (
                  <div className="cm-context-card nilai-empty-card">
                    <div className="cm-empty-state">
                      <div className="cm-empty-state-icon">
                        <FontAwesomeIcon icon={faBook} />
                      </div>
                      <h6>Data nilai belum tersedia</h6>
                      <p>Pastikan ekstrakurikuler dan semester tersedia pada filter yang dipilih.</p>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          )}

          {hasSearched && !isFetching && activeConfigTab === "pembina" && (
            <>
              {hasSearched && !isFetching && (
                <Col xl="12" sm="12">
                  <div className="config-matpel-workspace mt-3">
              

                    <div className="at-search mb-3">
                      <input
                          className="cm-search-input"
                          placeholder="Cari ekstrakurikuler..."
                          value={searchKeyword}
                          onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                    </div>

                    {visibleClassCards.length > 0 ? (
                      <>
                        <div className="cm-class-grid">
                          {visibleClassCards.map((kelas, index) => {
                            const kelasId = kelas?.ysb_kelas_id || "";
                            const titleKelas = kelas?.title || kelasId || "-";
                            const classTitle = String(titleKelas || "")
                              .toLowerCase()
                              .startsWith("kelas")
                              ? titleKelas
                              : `Kelas ${toTitleCase(titleKelas)}`;
                            const classSemesters =
                              getVisibleSemestersByKelas(kelasId);
                            const isActive =
                              String(kelasId) === String(resolvedActiveKelasId);

                            return (
                              <button
                                type="button"
                                key={`class-card-${kelasId}-${index}`}
                                className={`cm-class-card ${
                                  isActive ? "is-active" : ""
                                }`}
                                onClick={() => handleSelectClass(kelasId)}
                              >
                                <div className="cm-class-card-top">
                                  <span className="cm-class-icon">
                                    <FontAwesomeIcon icon={faChalkboardUser} />
                                  </span>

                                  <span>
                                    <span className="cm-class-name">
                                      {classTitle}
                                    </span>
                                    <span className="cm-class-meta">
                                      {getClassMapelCount(kelasId)} ekstrakurikuler
                                    </span>
                                  </span>
                                </div>

                                <div className="cm-class-semesters">
                                  {classSemesters.map((semester) => (
                                    <span
                                      key={`mini-semester-${kelasId}-${semester}`}
                                      className="cm-mini-chip"
                                    >
                                      Semester {semester}
                                    </span>
                                  ))}
                                </div>
                              </button>
                            );
                          })}
                        </div>

                        <div className="cm-context-card">
                          <div className="cm-context-head">
                            <div className="cm-context-title">
                              <h5>
                                {activeClassTitle} - Semester  {" "}
                                {resolvedActiveSemester}
                              </h5>
                              {/* <span className="cm-summary-badge">
                                {activeContextRowsWithoutSearch.length} Ekskul · {" "}
                                {activeTeacherCount} Pembina
                              </span> */}
                            </div>

                            <div className="cm-semester-switch">
                              {activeSemesterOptions.map((semester) => (
                                <button
                                  type="button"
                                  key={`semester-switch-${semester}`}
                                  className={`cm-semester-button ${
                                    Number(resolvedActiveSemester) ===
                                    Number(semester)
                                      ? "is-active"
                                      : ""
                                  }`}
                                  onClick={() => setActiveSemester(semester)}
                                >
                                  Semester {semester}
                                </button>
                              ))}
                            </div>
                          </div>

                          {activeContextRows.length > 0 ? (
                            <div className="cm-table-wrap">
                              <table className="cm-table">
                                <thead>
                                  <tr>
                                    <th style={{ width: "24%" }}>
                                      Ekstrakurikuler
                                    </th>
                                    <th style={{ width: "43%" }}>
                                      Pembina yang Ditugaskan
                                    </th>
                                    {/* <th style={{ width: "13%" }}>Status</th> */}
                                    <th
                                      style={{
                                        width: "10%",
                                        textAlign: "center",
                                      }}
                                    >
                                      Aksi
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {activeContextRows.map((row, rowIndex) => {
                                    const assignedTeachers = getResolvedTeachers(
                                      row,
                                      resolvedActiveKelasId,
                                      resolvedActiveSemester
                                    );
                                    const hasTeachers = assignedTeachers.length > 0;

                                    return (
                                      <tr
                                        key={`context-row-${
                                          row?.ysb_matpel_id || row?.id || rowIndex
                                        }`}
                                      >
                                        <td>
                                          <div className="cm-subject-cell">
                                            <span className="cm-subject-icon">
                                              <FontAwesomeIcon icon={faBook} />
                                            </span>
                                            <span>
                                              <span className="cm-subject-name">
                                                {row?.name_matpel || "-"}
                                              </span>
                                              <span className="cm-subject-caption">
                                                Semester {resolvedActiveSemester}
                                              </span>
                                            </span>
                                          </div>
                                        </td>

                                        <td>
                                          {hasTeachers ? (
                                            <div className="cm-teacher-list">
                                              {assignedTeachers.map(
                                                (teacher, teacherIndex) => (
                                                  <span
                                                    className="cm-teacher-chip"
                                                    key={`teacher-chip-${
                                                      teacher?.id ||
                                                      teacher?.teacher_id ||
                                                      teacherIndex
                                                    }`}
                                                    title={toTitleCaseGelar(
                                                      getTeacherName(teacher)
                                                    )}
                                                  >
                                                    <span className="cm-teacher-avatar">
                                                      {getTeacherInitials(teacher)}
                                                    </span>
                                                    <span className="cm-teacher-name">
                                                      {toTitleCaseGelar(
                                                        getTeacherName(teacher)
                                                      )}
                                                    </span>
                                                  </span>
                                                )
                                              )}
                                            </div>
                                          ) : (
                                            <span className="cm-empty-teacher">
                                              Belum ada pembina
                                            </span>
                                          )}
                                        </td>

                                        {/* <td>
                                          <span
                                            className={`cm-status ${
                                              hasTeachers
                                                ? "is-ready"
                                                : "is-empty"
                                            }`}
                                          >
                                            {hasTeachers
                                              ? "Sudah diisi"
                                              : "Belum diisi"}
                                          </span>
                                        </td> */}

                                        <td>
                                          <div className="cm-actions">
                                            {hasTeachers ? (
                                              <button
                                                type="button"
                                                className="config-matpel-table-button config-matpel-table-button-secondary"
                                                onClick={() =>
                                                  openUpdateGuruModal(
                                                    row,
                                                    resolvedActiveKelasId,
                                                    resolvedActiveSemester
                                                  )
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={faChalkboardUser}
                                                />
                                                Kelola Pembina
                                              </button>
                                            ) : (
                                              <button
                                                type="button"
                                                className="config-matpel-table-button config-matpel-table-button-primary"
                                                onClick={() =>
                                                  openTambahGuruModal(
                                                    row,
                                                    resolvedActiveKelasId,
                                                    resolvedActiveSemester
                                                  )
                                                }
                                              >
                                                <FontAwesomeIcon icon={faPlus} />
                                                Tambah Pembina
                                              </button>
                                            )}

                                            <button
                                              type="button"
                                              className="module-action-button module-action-edit"
                                              title="Ubah konfigurasi ekstrakurikuler"
                                              onClick={() => {
                                                setModalUpdate(true);
                                                setId(row.id);
                                                setNameUpdate(row.name_matpel);
                                                setUpdateData(row);
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faPenToSquare}
                                              />
                                            </button>

                                            <button
                                              type="button"
                                              className="module-action-button module-action-delete"
                                              title="Hapus ekstrakurikuler"
                                              onClick={() => deleteById(row)}
                                            >
                                              <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="cm-empty-state">
                              <div className="cm-empty-state-icon">
                                <FontAwesomeIcon icon={faBook} />
                              </div>
                              <h6>Data ekstrakurikuler tidak ditemukan</h6>
                              <p>
                                Coba ganti kata pencarian, kelas, atau semester.
                              </p>
                            </div>
                          )}

                          <div className="cm-info-note">
                            <span>ⓘ</span>
                            <span>
                              Tombol pembina hanya mengubah penugasan untuk kelas {" "}
                              <b>{activeClassTitle}</b> pada Semester {" "}
                              <b>{resolvedActiveSemester}</b>. Data kelas dan semester
                              lain tetap aman.
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="cm-context-card">
                        <div className="cm-empty-state">
                          <div className="cm-empty-state-icon">
                            <FontAwesomeIcon icon={faBook} />
                          </div>
                          <h6>Ekstrakurikuler belum ditambahkan</h6>
                          <p>
                            Tambahkan konfigurasi ekstrakurikuler untuk kelas yang
                            dipilih.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
              )}
            </>
          )}

          {hasSearched && !isFetching && activeConfigTab === "siswa" && (
            <Col xl="12" sm="12">
              <div className="config-matpel-workspace mt-3">
                <div className="at-search mb-3">
                  <input
                    className="cm-search-input"
                    placeholder="Cari ekstrakurikuler..."
                    value={studentSearchKeyword}
                    onChange={(e) => setStudentSearchKeyword(e.target.value)}
                  />
                </div>

                {visibleClassCards.length > 0 ? (
                  <>
                    <div className="cm-class-grid">
                      {visibleClassCards.map((kelas, index) => {
                        const kelasId = kelas?.ysb_kelas_id || "";
                        const titleKelas = kelas?.title || kelasId || "-";
                        const classTitle = String(titleKelas || "")
                          .toLowerCase()
                          .startsWith("kelas")
                          ? titleKelas
                          : `Kelas ${toTitleCase(titleKelas)}`;
                        const classSemesters =
                          getVisibleSemestersByKelas(kelasId);
                        const isActive =
                          String(kelasId) === String(resolvedActiveKelasId);

                        return (
                          <button
                            type="button"
                            key={`student-class-card-${kelasId}-${index}`}
                            className={`cm-class-card ${
                              isActive ? "is-active" : ""
                            }`}
                            onClick={() => handleSelectClass(kelasId)}
                          >
                            <div className="cm-class-card-top">
                              <span className="cm-class-icon">
                                <FontAwesomeIcon icon={faUsers} />
                              </span>

                              <span>
                                <span className="cm-class-name">
                                  {classTitle}
                                </span>
                                <span className="cm-class-meta">
                                  {getClassMapelCount(kelasId)} ekstrakurikuler
                                </span>
                              </span>
                            </div>

                            <div className="cm-class-semesters">
                              {classSemesters.map((semester) => (
                                <span
                                  key={`student-mini-semester-${kelasId}-${semester}`}
                                  className="cm-mini-chip"
                                >
                                  Semester {semester}
                                </span>
                              ))}
                            </div>
                          </button>
                        );
                      })}
                    </div>

                    <div className="cm-context-card">
                      <div className="cm-context-head">
                        <div className="cm-context-title">
                          <h5>
                            {activeClassTitle} - Semester {" "}
                            {resolvedActiveSemester}
                          </h5>
                        </div>

                        <div className="cm-semester-switch">
                          {(activeStudentSemesterTabs.length > 0
                            ? activeStudentSemesterTabs
                            : activeSemesterOptions.map((semester) => ({
                                id: `fallback-${semester}`,
                                number: Number(semester),
                                label: `Semester ${semester}`,
                              }))
                          ).map((semesterOption) => (
                            <button
                              type="button"
                              key={`student-semester-switch-${
                                semesterOption.id || semesterOption.number
                              }`}
                              data-semester-id={semesterOption.id || ""}
                              className={`cm-semester-button ${
                                Number(resolvedActiveSemester) ===
                                Number(semesterOption.number)
                                  ? "is-active"
                                  : ""
                              }`}
                              onClick={() =>
                                setActiveSemester(semesterOption.number)
                              }
                            >
                              {semesterOption.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      {activeStudentContextRows.length > 0 ? (
                        <div className="cm-table-wrap">
                          <table className="cm-table cm-student-table">
                            <thead>
                              <tr>
                                <th style={{ width: "30%" }}>
                                  Ekstrakurikuler
                                </th>
                               <th
  style={{
    width: "45%",
    textAlign: "center",
  }}
>
  Total Siswa
</th>
                                <th
                                  style={{
                                    width: "25%",
                                    textAlign: "center",
                                  }}
                                >
                                  Aksi
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {/* {activeStudentContextRows.map((row, rowIndex) => {
                                const assignedStudents = getResolvedStudents(
                                  row,
                                  resolvedActiveKelasId,
                                  resolvedActiveSemester
                                );
                                const hasStudents = assignedStudents.length > 0;
                                const previewStudents = assignedStudents.slice(0, 4);
                                const remainingStudents = Math.max(
                                  assignedStudents.length - previewStudents.length,
                                  0
                                );

                                return ( */}

                                {activeStudentContextRows.map((row, rowIndex) => {
  const studentTotal = getStudentTotal(
    row,
    resolvedActiveKelasId,
    resolvedActiveSemester
  );

  const hasStudents = studentTotal > 0;

  return (
                                  <tr
                                    key={`student-context-row-${
                                      row?.ysb_matpel_id || row?.id || rowIndex
                                    }`}
                                  >
                                    <td>
                                      <div className="cm-subject-cell">
                                        <span className="cm-subject-icon">
                                          <FontAwesomeIcon icon={faBook} />
                                        </span>
                                        <span>
                                          <span className="cm-subject-name">
                                            {row?.name_matpel || "-"}
                                          </span>
                                          <span className="cm-subject-caption">
                                            Semester {resolvedActiveSemester}
                                          </span>
                                        </span>
                                      </div>
                                    </td>

                                    {/* <td>
                                      {hasStudents ? (
                                        <div className="cm-student-assignment">
                                          <div className="cm-student-chip-list">
                                             {assignedStudents.length} siswa
                                            {previewStudents.map(
                                              (student, studentIndex) => (
                                                <span
                                                  className="cm-student-chip"
                                                  key={`student-chip-${
                                                    getStudentId(student) || studentIndex
                                                  }`}
                                                  title={toTitleCase(
                                                    getStudentName(student)
                                                  )}
                                                >
                                                  <span className="cm-student-avatar">
                                                    {getStudentInitials(student)}
                                                  </span>
                                                  <span className="cm-student-name">
                                                    {toTitleCase(
                                                      getStudentName(student)
                                                    )}
                                                  </span>
                                                </span>
                                              )
                                            )}

                                            {remainingStudents > 0 && (
                                              <span className="cm-student-more">
                                                +{remainingStudents} lainnya
                                              </span>
                                            )}
                                          </div>
                                          <span className="cm-student-total">
                                            {assignedStudents.length} siswa
                                          </span>
                                        </div>
                                      ) : (
                                        <span className="cm-empty-student">
                                          Belum ada siswa
                                        </span>
                                      )}
                                    </td> */}

                                    <td style={{ textAlign: "center" }}>
  <button
    type="button"
    onClick={() =>
      openStudentListModal(
        row,
        resolvedActiveKelasId,
        resolvedActiveSemester
      )
    }
    disabled={!hasStudents}
    title={
      hasStudents
        ? "Klik untuk melihat daftar siswa"
        : "Belum ada siswa terdaftar"
    }
    style={{
      border: hasStudents
        ? "1px solid #c7d2fe"
        : "1px solid #e5e7eb",

      backgroundColor: hasStudents
        ? "#eef2ff"
        : "#f9fafb",

      color: hasStudents
        ? "#3f5bea"
        : "#9ca3af",

      borderRadius: "999px",

      padding: "7px 14px",

      fontSize: "13px",

      fontWeight: 700,

      display: "inline-flex",

      alignItems: "center",

      justifyContent: "center",

      gap: "7px",

      cursor: hasStudents
        ? "pointer"
        : "not-allowed",

      minWidth: "105px",
    }}
  >
    <FontAwesomeIcon icon={faUsers} />

    {studentTotal} siswa
  </button>
</td>


                                    <td>
                                      <div className="cm-actions">
                                        <button
                                          type="button"
                                          className={`config-matpel-table-button ${
                                            hasStudents
                                              ? "config-matpel-table-button-secondary"
                                              : "config-matpel-table-button-primary"
                                          }`}
                                          onClick={() =>
                                            openTambahSiswaModal(
                                              row,
                                              resolvedActiveKelasId,
                                              resolvedActiveSemester,
                                              hasStudents ? "update" : "create"
                                            )
                                          }
                                        >
                                          <FontAwesomeIcon
                                            icon={hasStudents ? faUsers : faUserPlus}
                                          />
                                          {hasStudents
                                            ? "Kelola Siswa"
                                            : "Tambah Siswa"}
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className="cm-empty-state">
                          <div className="cm-empty-state-icon">
                            <FontAwesomeIcon icon={faUsers} />
                          </div>
                          <h6>Data ekstrakurikuler tidak ditemukan</h6>
                          <p>
                            Coba ganti kata pencarian, kelas, atau semester.
                          </p>
                        </div>
                      )}

                      <div className="cm-info-note">
                        <span>ⓘ</span>
                        <span>
                          Saat menambah siswa, kamu bisa memilih siswa satu per
                          satu atau mencentang satu kelas untuk langsung memilih
                          seluruh siswa pada kelas tersebut. Kelas yang tampil
                          tetap dalam tingkatan yang sama.
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="cm-context-card">
                    <div className="cm-empty-state">
                      <div className="cm-empty-state-icon">
                        <FontAwesomeIcon icon={faUsers} />
                      </div>
                      <h6>Ekstrakurikuler belum ditambahkan</h6>
                      <p>
                        Tambahkan konfigurasi ekstrakurikuler terlebih dahulu
                        pada tab Pembina.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          )}
        </div>
      </div>
    </>
  );
}
